/* eslint-disable */
<template>
  <q-page padding >
    <h2 class="text-center">Import from Order Form</h2>
		<q-dialog v-model="showRulesDialog" v-if="showRulesDialog">
			<q-card class="my-card" style="min-width: 740px" v-if="rules[currentEditingRule]">
				<q-card-section>
          <div class="text-h6">Set data range:</div>
          <br>    
          <div class="row">
            <div style="width: 150px; line-height: 40px; text-align: center;">{{currentEditingRule}}:</div>
            <q-input dense outlined style="width:160px; margin: 0 10px" :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" v-model="attributes2[currentEditingRule].range"/>
          </div>  
          <br>
        <q-separator />
				</q-card-section>
				<q-card-section>
          <div class="text-h6">Set rules:</div>
          <br>          
					<div class="row">
						<div class="text-bold" style="line-height:40px;">Sample Input:</div>
            <q-input style="margin-left: 10px; width:400px" outlined dense v-model="sampleInput[currentEditingRule]" type="text"/>
					</div>
				</q-card-section>	
				<q-card-section class="q-pt-none">
          <div v-for="(ruleData,index) in rules[currentEditingRule]" class="row" :key="index" style="margin-bottom:10px"> 
              <div style="min-width:35px">
                <q-btn flat dense icon="delete" @click="rules[currentEditingRule].pop()" v-if="rules[currentEditingRule].length == index+1 && index != 0"></q-btn>
              </div >              
              <q-select outlined dense v-model="ruleData.rule" :options="rulesOptions" option-value="id" option-label="desc" option-disable="inactive" emit-value map-options style="min-width: 180px; max-width: 180px;" />            
              <template v-if="ruleData.rule.includes('replace')">
                <q-input dense outlined style="width:200px; margin: 0 10px" v-model="ruleData.input[0]"/>
                <div style="line-height:40px;">for</div>
                <q-input dense outlined style="width:200px; margin: 0 10px" v-model="ruleData.input[1]"/>
              </template>
              <template  v-if="ruleData.rule.includes('add')">
                <q-input dense outlined style="width:200px; margin: 0 10px" v-model="ruleData.input[0]"/>
              </template>
              <template  v-if="ruleData.rule.includes('splitBy')">
                <q-input dense outlined style="width:200px; margin: 0 10px" v-model="ruleData.input[0]"/>
              </template>
              <template  v-if="ruleData.rule.includes('regexMatch')">
                <q-input dense outlined style="width:200px; margin: 0 10px" v-model="ruleData.input[0]"/>
              </template>
              <template  v-if="ruleData.rule.includes('multiply')">
                <q-input dense outlined style="width:200px; margin: 0 10px" v-model="ruleData.input[0]"/>
              </template>                                           
              <q-btn style="margin-top:5px; width:30px; height:30px" size="sm" color="primary" round v-if="rules[currentEditingRule].length == index+1" @click="addRule(currentEditingRule)" icon="add"/>
          </div>  
				</q-card-section>
				<q-card-actions align="center">
				<q-btn color="primary" label="Apply Rules" @click="applyRulesOnDialog(currentEditingRule)"/>
				</q-card-actions>        
				<q-card-section class="q-pt-none">
					<div class="row">
						<div class="text-bold" >Result:</div>
            <span style="margin-left: 20px; width:400px">{{rulesResult[currentEditingRule]}}</span>
					</div>
				</q-card-section>        
				<q-separator />
				<q-card-actions align="right">
				<q-btn v-close-popup flat color="black" label="Cancel" />
				<q-btn v-close-popup flat color="primary" label="Apply"/>
				</q-card-actions>
			</q-card>
		</q-dialog>		

		<q-dialog v-model="showNewRevisionDialog" v-if="showNewRevisionDialog">
			<q-card class="" style="min-width: 440px">     
				<q-card-section>
          <div class="text-h6">New Revision</div>
          <q-separator />
          <br>          
					<div class="row" style="margin:20px 0">
						<div class="text-bold" style="line-height:40px;" >Revision Name:</div>
            <q-input style="margin-left: 10px; width:400px" outlined dense v-model="newRevisionName" type="text"/>
            <div class="text-bold" style="line-height:40px;" >Revision</div><div style="line-height:40px;margin-left:10px">(default):</div><div style="line-height:40px;margin-left:10px">Rev. {{revisionList.length ? Number(revisionList[0].rev) + 1 : 1}}</div>
					</div>
				</q-card-section>	      
				<q-separator />
				<q-card-actions align="right">
				<q-btn v-close-popup flat color="black" label="Cancel" @click="newRevisionName = ''" />
				<q-btn v-close-popup flat color="primary" label="Create" @click="createNewRevision"/>
				</q-card-actions>
			</q-card>
		</q-dialog>		  
<br>
    <div class="q-pa-md">
      <q-btn label="Reset" push color="white" text-color="primary" @click="step = 1" class="q-mb-md" />
      <q-stepper v-model="step" header-nav ref="stepper" color="primary" animated >

        <!-- STEP 1 -->
        <q-step :name="1" title="Load spreadsheet" icon="settings" :done="step > 1" :header-nav="step > 1" >
          <q-stepper-navigation>                 
            <div class="text-h6">Revision</div>
            <div class="row">
              <div style="line-height:40px; margin-right:30px" v-if="revisionList.length">Selected Revision:</div>
              <q-select outlined dense v-model="currentRevision" :options="revisionList" style="min-width:500px" v-if="revisionList.length"/>
              <div style="line-height:40px; margin-right:30px; margin:0 40px" v-if="revisionList.length">--or--</div>
              <q-btn color="primary" label="Create New Revision" @click="newRevisionDialog" />
            </div> 
            <br>
            <q-separator/>
            <div class="text-h6" style="margin:20px 0">Order Form</div>
            <div class="row">
              <div class="col-12 col-md-6">
                <q-uploader ref="coloursUploader" hide-upload-btn @added="xlsxUploader" :max-files="1" label="Upload Order Form" accept=".xlsx" style="width:400px">
                  <template v-slot:header="scope">
                    <div class="row no-wrap items-center q-pa-sm q-gutter-xs">
                      <div class="col">
                          <div class="q-uploader__title">Upload Order Form</div>
                          <div class="q-uploader__subtitle">File format: .xlsx</div>
                      </div>
                      <q-btn v-if="scope.canAddFiles" type="a" icon="add_box" round dense flat>
                      <q-uploader-add-trigger />
                      <q-tooltip>Select Files</q-tooltip>
                      </q-btn>
                    </div>
                  </template>
                  <template v-slot:list="scope">
                      <q-list separator>
                          <q-item v-for="file in scope.files" :key="file.name">
                              <q-item-section style="max-width:35px">
                                  <q-icon color="green" size="md" name="done" v-if="fileProcess.status == 'Done'"/>
                                  <q-icon color="red" size="md" name="report_problem" v-if="fileProcess.status == 'Error'"/>
                                  <q-icon color="blue" size="md" name="file_upload" v-if="fileProcess.status == 'Loading'"/>
                              </q-item-section>
                              <q-item-section>
                                  <q-item-label class="full-width text-bold"> {{ setFilename(file.name) }} </q-item-label>
                              </q-item-section>
                              <q-item-section top side>
                                  <q-btn class="gt-xs" size="12px" flat dense round icon="delete" @click="resetFilePicker(file,scope.removeFile)" />
                              </q-item-section>
                          </q-item>
                          <q-banner inline-actions class="text-white bg-red" v-if="fileProcess.status == 'Error'"> {{fileProcess.errorMessage}} </q-banner>
                          <q-inner-loading :showing="fileProcess.loading">
                              <q-spinner size="40px" color="primary" />
                          </q-inner-loading>
                      </q-list>
                  </template> 
                </q-uploader>   
              </div>
              <div class="col-12 col-md-6">
                <div style="width: 300px" v-if="showSheetSelector">
                  <span>Select Sheet:</span>
                  <q-select @input="sheetName => setSheetToUse(sheetName)" filled v-model="sheetSelected" :options="sheets" label="Available Sheets" />
                </div>
              </div>
            </div> 
            <br><br>      
            <q-btn @click="() => { done1 = true; step = 2; loadSavedData()}" color="primary" label="Continue" :disable="!enableToStep2"/>
          </q-stepper-navigation>
        </q-step>

        <!-- STEP 2 -->
        <q-step :name="2" title="Add Attributes" icon="settings" :done="step > 2" :header-nav="step > 2">
          <div class="row">       
            <div class="col-12 col-md-9 col-lg-8">
              <div class="text-h6">Product Details</div>
              <br>
              <div class="row">
                <div style="width: 100px; line-height: 44px; text-align: center;">Manufacturer</div>
                <q-select :rules="[myRule]" style="width:180px; " outlined v-model="productManufacturer" :options="Object.keys(productDetailsList)" @input="productBrand=''"  dense :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" />
                <div style="width: 100px; line-height: 44px; text-align: center;">Brand</div>
                <q-select :rules="[myRule]" style="width:180px; " outlined v-model="productBrand" :options="Object.keys(productDetailsList[productManufacturer]||{})"  @input="productMaterial=''" dense :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" />
                <div style="width: 100px; line-height: 44px; text-align: center;">Material</div>
                <q-select :rules="[myRule]" style="width:160px; " outlined v-model="productMaterial" :options="(productManufacturer && productBrand)?productDetailsList[productManufacturer][productBrand]:[]" dense :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" />
              </div> 
              <q-separator  />                        
              <div class="row" style="margin:30px 0">
                <div class="text-bold text-center" style="width: 150px;">Attribute</div>
                <div class="text-bold text-center" style="width: 120px;">Input Type</div>
                <div class="text-bold text-center" style="width: 200px;">Selection Range</div>
                <div class="text-bold text-center" style="width: 120px;">Use Attribute</div>
                <div class="text-bold text-center" style="width: 120px;">Use as reference</div>
              </div>
              <div class="row" style="margin-bottom:10px">
                <div class="row" style="width:100%">
                  <div style="width: 150px; line-height: 44px; text-align: center;color:#C71F25">
                    <span><q-tooltip>Required attribute</q-tooltip>Colour</span>
                  </div>
                  <q-select style="width:120px; margin: 0 10px" outlined value="Range" :options="['Range']" dense :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" />                
                  <q-input :rules="[myRule]" v-model="attributes2.colour.range" dense outlined style="width:160px; margin: 0 10px" :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}"/>
                </div>                                                                 
                <div class="row" style="width:100%">
                  <div style="width: 150px; line-height: 44px; text-align: center; color:#C71F25">
                    <span><q-tooltip>Required attribute</q-tooltip>Name</span>
                  </div>
                  <q-select style="width:120px; margin: 0 10px" outlined v-model="inputType['name']" :options="['Range','Text','Number','Special']" dense :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" />                  
                  <q-input :rules="[myRule]" dense outlined style="width:160px; margin: 0 10px" :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}"  v-model="attributes2.name.range" v-if="inputType['name'] != 'Special'"/>
                  <q-btn style="width:160px; margin: 0 10px 6px 10px" size="md" color="primary" label="Rules" @click="rulesDialog('name')" v-if="inputType['name'] == 'Special'"/>
                  <q-checkbox style="margin: 0 40px" v-model="attributes2.name.addAttribute" />
                  <q-radio style="margin: 0 40px" v-model="attributeAsReference" :val="attributes2.name.id" />
                </div>
                <div class="row" style="width:100%">
                  <div style="width: 150px; line-height: 44px; text-align: center; color:#C71F25">
                    <span><q-tooltip>Required attribute</q-tooltip>Reference</span>
                  </div>
                  <q-select style="width:120px; margin: 0 10px" outlined v-model="inputType['reference']" :options="['Range','Text','Number','Special']" dense :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" />                  
                  <q-input :rules="[myRule]"  dense outlined style="width:160px; margin: 0 10px" :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" v-model="attributes2.reference.range" v-if="inputType['reference'] != 'Special'"/>
                  <q-btn style="width:160px; margin: 0 10px 6px 10px" size="md" color="primary" label="Rules" @click="rulesDialog('reference')" v-if="inputType['reference'] == 'Special'"/>                  
                  <q-checkbox style="margin: 0 40px" v-model="attributes2.reference.addAttribute" />
                  <q-radio style="margin: 0 40px" v-model="attributeAsReference" :val="attributes2.reference.id" />
                </div>
                <div class="row" style="width:100%">
                  <div style="width: 150px; line-height: 44px; text-align: center;color:#C71F25">
                    <span><q-tooltip>Required attribute</q-tooltip>Price</span>                    
                  </div>
                  <q-select style="width:120px; margin: 0 10px" outlined v-model="inputType['price']" :options="['Range','Text','Number','Special']" dense :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" />                  
                  <q-input :rules="[myRule]" dense outlined style="width:160px; margin: 0 10px" :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" v-model="attributes2.price.range" v-if="inputType['price'] != 'Special'"/>
                  <q-btn style="width:160px; margin: 0 10px 6px 10px" size="md" color="primary" label="Rules" @click="rulesDialog('price')" v-if="inputType['price'] == 'Special'"/>                  
                  <q-checkbox style="margin: 0 40px" v-model="attributes2.price.addAttribute" />
                  <q-radio style="margin: 0 40px" v-model="attributeAsReference" :val="attributes2.price.id" />
                </div>                
                <div class="row" style="width:100%">
                  <div style="width: 150px; line-height: 44px; text-align: center;">Grip</div>
                  <q-select style="width:120px; margin: 0 10px" outlined v-model="inputType['grip']" :options="['Range','Text','Number','Special']" dense :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" />                  
                  <q-input dense outlined style="width:160px; margin: 0 10px" :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" v-model="attributes2.grip.range" v-if="inputType['grip'] != 'Special'"/>                  
                  <q-btn style="width:160px; margin: 0 10px 6px 10px" size="md" color="primary" label="Rules" @click="rulesDialog('grip')" v-if="inputType['grip'] == 'Special'"/>                  
                  <q-checkbox style="margin: 0 40px" v-model="attributes2.grip.addAttribute" />
                  <q-radio style="margin: 0 40px" v-model="attributeAsReference" :val="attributes2.grip.id" />
                </div>
                <div class="row" style="width:100%">
                  <div style="width: 150px; line-height: 44px; text-align: center;"># of Holds</div>
                  <q-select style="width:120px; margin: 0 10px" outlined v-model="inputType['holds']" :options="['Range','Text','Number','Special']" dense :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" />                  
                  <q-input dense outlined style="width:160px; margin: 0 10px" :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" v-model="attributes2.holds.range" v-if="inputType['holds'] != 'Special'"/>
                  <q-btn style="width:160px; margin: 0 10px 6px 10px" size="md" color="primary" label="Rules" @click="rulesDialog('holds')" v-if="inputType['holds'] == 'Special'"/>                  
                  <q-checkbox style="margin: 0 40px" v-model="attributes2.holds.addAttribute" />
                  <q-radio style="margin: 0 40px" v-model="attributeAsReference" :val="attributes2.holds.id" />
                </div>
                <div class="row" style="width:100%">
                  <div style="width: 150px; line-height: 44px; text-align: center;">Range</div>
                  <q-select style="width:120px; margin: 0 10px" outlined v-model="inputType['range']" :options="['Range','Text','Number','Special']" dense :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" />                  
                  <q-input dense outlined style="width:160px; margin: 0 10px" :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" v-model="attributes2.range.range" v-if="inputType['range'] != 'Special'"/>
                  <q-btn style="width:160px; margin: 0 10px 6px 10px" size="md" color="primary" label="Rules" @click="rulesDialog('range')" v-if="inputType['range'] == 'Special'"/>                  
                  <q-checkbox style="margin: 0 40px" v-model="attributes2.range.addAttribute" />
                  <q-radio style="margin: 0 40px" v-model="attributeAsReference" :val="attributes2.range.id" />
                </div>  
                <div class="row" style="width:100%">
                  <div style="width: 150px; line-height: 44px; text-align: center;">Size</div>
                  <q-select style="width:120px; margin: 0 10px" outlined v-model="inputType['size']" :options="['Range','Text','Number','Special']" dense :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" />                  
                  <q-input dense outlined style="width:160px; margin: 0 10px" :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" v-model="attributes2.size.range" v-if="inputType['size'] != 'Special'"/>
                  <q-btn style="width:160px; margin: 0 10px 6px 10px" size="md" color="primary" label="Rules" @click="rulesDialog('size')" v-if="inputType['size'] == 'Special'"/>                  
                  <q-checkbox style="margin: 0 40px" v-model="attributes2.size.addAttribute" />
                  <q-radio style="margin: 0 40px" v-model="attributeAsReference" :val="attributes2.size.id" />
                </div> 
                <div class="row" style="width:100%">
                  <div style="width: 150px; line-height: 44px; text-align: center;">Type</div>
                  <q-select style="width:120px; margin: 0 10px" outlined v-model="inputType['type']" :options="['Range','Text','Number','Special']" dense :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" />                  
                  <q-input dense outlined style="width:160px; margin: 0 10px" :input-style="{ fontFamily: 'Courier', fontWeight: 'bold', fontSize:'16px'}" v-model="attributes2.type.range" v-if="inputType['type'] != 'Special'"/>
                  <q-btn style="width:160px; margin: 0 10px 6px 10px" size="md" color="primary" label="Rules" @click="rulesDialog('type')" v-if="inputType['type'] == 'Special'"/>                                    
                  <q-checkbox style="margin: 0 40px" v-model="attributes2.type.addAttribute" />
                  <q-radio style="margin: 0 40px" v-model="attributeAsReference" :val="attributes2.type.id" />
                </div>                                                                                                                                  
              </div>  
            </div>
            <div class="col-12 col-md-3 col-lg-4" style="border-left:solid 1px silver; padding-left: 15px">
              <div class="text-h6">Save Ranges</div>
              <br>
              <div class="row">
                <div class="text-bold" style="line-height:40px; min-width:70px">Save as:</div>
                <q-input style="margin-left: 10px; width:100%" outlined dense v-model="saveOFDataAs" type="text"/>
              </div>
              <div class="row">
                <div class="text-bold" style="line-height:40px; min-width:70px">Notes:</div>
                <q-input style="margin-left: 10px; width:100%" outlined dense v-model="saveOFNotes" type="textarea" autogrow/>
              </div>
              <div class="text-right" style="margin-top:30px"><q-btn color="primary" label="Save" @click="createSavedOFData" :disable="validateInputsForSave"/></div>
              <br>
              <q-separator  />
              <br>
              <div class="text-h6">Load Ranges</div>
              <br>
              <q-select outlined dense v-model="selectedSavedOFData" :options="savedOFDataList" style="width:100%"/>
              <br>
              <template v-if="selectedSavedOFData != ''">
                <div class="row">
                  <div class="text-right text-bold" style="width:70px;">Filename:</div><div style="margin-left:10px">{{selectedSavedOFData.filename}}</div>
                </div>
                <div class="row">
                  <div class="text-right text-bold" style="width:70px;margin-right;10px">Sheet:</div><div style="margin-left:10px">{{selectedSavedOFData.sheet}}</div>
                </div>
                <div class="row">
                  <div class="text-right text-bold" style="width:70px;margin-right;10px">Notes:</div><div style="margin-left:10px;width:80%;overflow-wrap: break-word;">{{selectedSavedOFData.notes}}</div>
                </div>
                <div class="row">
                  <div class="text-right text-bold" style="width:70px;margin-right;10px">Revision:</div><div style="margin-left:10px">Rev.{{selectedSavedOFData.rev}}</div>
                </div>
                <div class="row">
                  <div class="text-right text-bold" style="width:70px;margin-right;10px">Created:</div><div style="margin-left:10px">{{moment(selectedSavedOFData.createdAt).format("DD/MMM/YY HH:mm:ss")}}</div>
                </div>                                                               
              </template>
              <div class="text-right" style="margin-top:30px"><q-btn color="primary" label="Load" @click="loadAttributes" :disable="selectedSavedOFData == '' || dataLoaded" /></div>
            </div>
          </div>
          <br><br>
          <q-stepper-navigation>
    
            <q-btn @click="() => { done2 = true; step = 3; process()}" color="primary" label="Continue" :disable="validateInputs"/>
            <q-btn flat @click="step = 1" color="primary" label="Back" class="q-ml-sm" />
          </q-stepper-navigation>
        </q-step>

        <!-- STEP 3 -->
        <q-step :name="3" title="Select Colour" icon="settings" :done="step > 3" :header-nav="step > 3" >
          <div v-if="additionalColours.length">
            <div class="text-h6">Additional Colours</div>
            <template v-for="(colour,index) in additionalColours">
            <div class="row" style="margin-left: 15px" :key="index">
              <q-checkbox v-model="selectedAdditionalColours" :val="colour" color="teal" >
                <div class="row">
                  <div :style="{'border': 'solid silver 1px', 'margin-top': '3px', 'margin-right':'5px', 'max-height':'15px', 'min-width': '15px', 'background-color':colour.hex}"></div>
                  <div>{{colour.supergroup}} ➜ {{colour.group}} ➜ {{colour.name}} ({{colour.material}}) </div>
                </div>                    
              </q-checkbox>                  
            </div>  
            </template>
            <br>
            <q-separator />
            <br>
          </div>
          <div class="text-h6">Matched Order Form Colours</div>
          <div v-for="(matchedColours, formColourName, index) in coloursMatched" :key="index" v-if="showColourSelectorPage">                
            <div class="q-pa-md row" style="border-bottom: solid 1px #d6d6d6">
              <div style="width:200px; padding-top:8px" class="text-bold"><q-icon name="warning" size="sm" color="red" v-if="matchedColours.length > 1" />{{formColourName}}</div>
              <div class="col">
                <div class="row" v-if="matchedColours.length == 0">
                  <div><q-icon name="warning" size="sm" color="red"></q-icon>There is no match for this colour in our database. You may need to create the colour first <q-btn color="primary" :to="{ path: '/admin/add-colour'}">Create Colour</q-btn></div>
                </div>                    
                <div class="row" v-if="matchedColours.length == 1">
                  <div :style="{'border': 'solid silver 1px', 'margin-top': '3px', 'margin-right':'5px', 'max-height':'15px', 'min-width': '15px', 'background-color':matchedColours[0].hex}"></div>
                  <div>{{matchedColours[0].supergroup}} ➜ {{matchedColours[0].group}} ➜ {{matchedColours[0].name}} </div>
                </div>
                <div class="row" v-if="matchedColours.length > 1">
                  <template v-for="(matchedColourOption, indx) in matchedColours" >
                  <q-radio size="xs" v-model="selectedColourToSave[formColourName]" :val="matchedColourOption" class="row" :key="indx">
                    <div class="row">
                      <div :style="{'border': 'solid silver 1px', 'margin-top': '3px', 'margin-right':'5px', 'max-height':'15px', 'min-width': '15px', 'background-color':matchedColourOption.hex}"></div>
                      <div>{{matchedColourOption.supergroup}} ➜ {{matchedColourOption.group}} ➜ {{matchedColourOption.name}}</div>
                    </div>
                  </q-radio>
                  </template>
                </div>                    
              </div>
            </div>
          </div>
 
   
          <q-stepper-navigation>
            <q-btn @click="() => { done3 = true; step = 4; setColours()}" color="primary" label="Continue" :disable="verifyColourSelection"/>
            <q-btn flat @click="step = 2" color="primary" label="Back" class="q-ml-sm" />
          </q-stepper-navigation>  
        </q-step>

        <!-- STEP 4 -->
        <q-step :name="4" title="Add Price" icon="add_comment" :header-nav="step >  4" >
          <transition appear enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" >
            <div class="row text-bold" v-show="showPriceSelectorPage">
              <div style="width:200px; padding-left: 15px">
                <div>Exchange Rate:</div>             
                <q-input autofocus dense outlined v-model="fxrate" :rules="[ (val) => !!val || 'Exchange Rate required' ]" @input="()=>{checkInputs()}"></q-input>
              </div>
              <div style="width:200px; padding-left: 15px">
                <div>Variation Value:</div>            
                <q-input dense outlined v-model="variation" :rules="[ (val) => !!val || 'Variation value required' ]" @input="()=>{checkInputs()}"></q-input>
              </div>
              <div style="width:200px; padding-left: 15px">        
                <div>Upsale:</div>
                <q-input dense outlined v-model="upsale"></q-input>
              </div>
              <div style="width:220px; padding-left: 15px">        
                <div>Special Colours Surcharge (%):</div>
                <q-input dense outlined v-model="surcharge"></q-input>
              </div>        
            </div>
          </transition>
          <q-inner-loading :showing="showLoadingPriceSelectorPage" >
            <div style="padding:50px">
              <span style="diplay: block;font-weight: bold;">Loading Database</span>
              <q-spinner-gears size="200px" color="primary" />      
            </div>  
          </q-inner-loading>        
          <q-stepper-navigation>
            <q-btn color="primary" @click="()=> {done4 = true; secondStepProcess()}" label="Process Data" :disable="disableSetPriceButton"/>
            <q-btn flat @click="step = 3" color="primary" label="Back" class="q-ml-sm" />
          </q-stepper-navigation>  
        </q-step>
      </q-stepper>
    </div>



<!-- END OF STEPPER -->



  
  <div v-if="allDone" >   
    <div class="q-pa-md">
      <div class="q-gutter-y-md" >
        <q-option-group
          v-model="panel"
          inline
          :options="[
            { label: 'Found', value: 'matched' },
            { label: 'Not Found / New', value: 'notMatched' },
            { label: 'Summary', value: 'summary' }
          ]"
        />

        <q-tab-panels v-model="panel" animated class="shadow-2 rounded-borders">
          <q-tab-panel name="matched" v-if="renderThis">
            <template v-if="showMatchedAttributesPanel">
              <q-table
                :style="{maxHeight: tableHeight }"
                :data="foundProducts"
                :columns="columns()"
                :pagination="{rowsPerPage: 0}"
                binary-state-sort
                flat
                row-key="reference" >
                <template v-slot:top="props">
                  <div class="row justify-end">
                    <div class="text-h6">Found {{foundProducts.length}} products already on our Database</div>
                    <q-btn flat round dense :icon="props.inFullscreen ? 'fullscreen_exit' : 'fullscreen'" @click="toggleFullscreen(props)" class="q-ml-md" />
                    <q-btn flat round dense icon="task_alt" @click="selectAllFound()" class="q-ml-md" />
                  </div>
                </template>
                <template v-slot:body-cell-selected="props">
                  <q-td :props="props">
                    <q-checkbox v-model="props.row.selected" />
                  </q-td>
                </template>                   
                <template v-slot:body-cell-name="props">
                  <q-td :props="props">
                    <div v-if="props.row.differences.name">
                      <span style="color:red; text-decoration: line-through; margin-right: 5px">{{props.row.differences.name.old}}</span>
                      <span style="color:green">{{props.row.differences.name.new}}</span>
                      <q-btn flat dense color="blue" size="xs" icon="undo" style="margin-left:10px" @click="discard_changes(props,props.row,'name')">
                        <q-tooltip transition-show="scale" transition-hide="scale" content-style="color:black; font-weigth:bold; background: white; border: solid 1px black"> Discard Changes </q-tooltip>                     
                      </q-btn>                    
                    </div>
                    <div v-else>{{props.value}}</div>
                  </q-td>
                </template> 
                <template v-slot:body-cell-range="props">
                  <q-td :props="props">
                    <div v-if="props.row.differences.range">
                      <span style="color:red; text-decoration: line-through; margin-right: 5px">{{props.row.differences.range.old}}</span>
                      <span style="color:green">{{props.row.differences.range.new}}</span>
                      <q-btn flat dense color="blue" size="xs" icon="undo" style="margin-left:10px" @click="discard_changes(props,props.row,'range')">
                        <q-tooltip transition-show="scale" transition-hide="scale" content-style="color:black; font-weigth:bold; background: white; border: solid 1px black"> Discard Changes </q-tooltip>                     
                      </q-btn>
                    </div>
                    <div v-else>{{props.value}}</div>
                  </q-td>
                </template>
                <template v-slot:body-cell-type="props">
                  <q-td :props="props">
                    <div v-if="props.row.differences.type">                      
                      <span style="color:red; text-decoration: line-through; margin-right: 5px">{{props.row.differences.type.old}}</span>
                      <span style="color:green">{{props.row.differences.type.new}}</span>
                      <q-btn flat dense color="blue" size="xs" icon="undo" style="margin-left:10px" @click="discard_changes(props,props.row,'type')">
                        <q-tooltip transition-show="scale" transition-hide="scale" content-style="color:black; font-weigth:bold; background: white; border: solid 1px black"> Discard Changes </q-tooltip>                     
                      </q-btn>                    
                    </div>
                    <div v-else>{{props.value}}</div>
                  </q-td>
                </template>
                <template v-slot:body-cell-material="props">
                  <q-td :props="props">
                    <div v-if="props.row.differences.material">
                      <span style="color:red; text-decoration: line-through; margin-right: 5px">{{props.row.differences.material.old}}</span>
                      <span style="color:green">{{props.row.differences.material.new}}</span>
                      <q-btn flat dense color="blue" size="xs" icon="undo" style="margin-left:10px" @click="discard_changes(props,props.row,'material')">
                        <q-tooltip transition-show="scale" transition-hide="scale" content-style="color:black; font-weigth:bold; background: white; border: solid 1px black"> Discard Changes </q-tooltip>                     
                      </q-btn>                    
                      </div>
                    <div v-else>{{props.value}}</div>
                  </q-td>
                </template>
                <template v-slot:body-cell-size="props">
                  <q-td :props="props">
                    <div v-if="props.row.differences.size">
                      <span style="color:red; text-decoration: line-through; margin-right: 5px">{{props.row.differences.size.old}}</span>
                      <span style="color:green">{{props.row.differences.size.new}}</span>
                      <q-btn flat dense color="blue" size="xs" icon="undo" style="margin-left:10px" @click="discard_changes(props,props.row,'size')">
                        <q-tooltip transition-show="scale" transition-hide="scale" content-style="color:black; font-weigth:bold; background: white; border: solid 1px black"> Discard Changes </q-tooltip>                     
                      </q-btn>                    
                    </div>
                    <div v-else>{{props.value}}</div>
                  </q-td>
                </template>                                                                                                
                <template v-slot:body-cell-grip="props">
                  <q-td :props="props">
                    <div v-if="props.row.differences.grip">
                      <span style="color:red; text-decoration: line-through; margin-right: 5px">{{props.row.differences.grip.old}}</span>
                      <span style="color:green">{{props.row.differences.grip.new}}</span>
                      <q-btn flat dense color="blue" size="xs" icon="undo" style="margin-left:10px" @click="discard_changes(props,props.row,'grip')">
                        <q-tooltip transition-show="scale" transition-hide="scale" content-style="color:black; font-weigth:bold; background: white; border: solid 1px black"> Discard Changes </q-tooltip>                     
                      </q-btn>                    
                    </div>
                    <div v-else>{{props.value}}</div>
                  </q-td>
                </template>    
                <template v-slot:body-cell-holds="props">
                  <q-td :props="props">
                    <div v-if="props.row.differences.holds">
                      <span style="color:red; text-decoration: line-through; margin-right: 5px">{{props.row.differences.holds.old}}</span>
                      <span style="color:green">{{props.row.differences.holds.new}}</span>
                      <q-btn flat dense color="blue" size="xs" icon="undo" style="margin-left:10px" @click="discard_changes(props,props.row,'holds')">
                        <q-tooltip transition-show="scale" transition-hide="scale" content-style="color:black; font-weigth:bold; background: white; border: solid 1px black"> Discard Changes </q-tooltip>                     
                      </q-btn>                    
                    </div>
                    <div v-else>{{props.value}}</div>
                  </q-td>
                </template>                                            
                <template v-slot:body-cell-reference="props">
                  <q-td :props="props">
                    <router-link :to="`/admin/products/${props.row.id}`">{{props.value}}</router-link>
                  </q-td>
                </template>
                <template v-slot:body-cell-change="props">
                  <q-td :props="props">
                    <span v-if="props.value > 0" style="color:green">{{props.value}}%</span>
                    <span v-if="props.value < 0" style="color:red">{{props.value}}%</span>
                    <span v-if="props.value == 0" >{{props.value}}%</span>
                    <q-icon color="orange" size="xs" name="warning_amber" v-if="props.value > 40 || props.value < -40">
                      <q-tooltip transition-show="scale" transition-hide="scale" content-style="color:black; font-weigth:bold; background: white; border: solid 1px black">Is the new price correct?</q-tooltip>                     
                    </q-icon>
                  </q-td>
                </template>                                      
              </q-table>
              <div class="row justify-end" style="margin:30px"> 
                <q-btn color="primary" @click="gotoMatchedColourPanel" label="Next" class="q-ml-sm" :disable="foundProducts.length == 0"/>
              </div>
            </template>
            <template v-if="showMatchedColourPanel && foundProducts.length > 0">
              <q-table
                :style="{maxHeight: tableHeight }"
                :data="foundProducts"
                :columns="columnsColour()"
                :pagination="{rowsPerPage: 0}"
                binary-state-sort
                flat   
                row-key="reference" >
                <template v-slot:top="props">
                  <div class="row justify-end">
                    <div class="text-h6">Colour Mixer</div>
                    <q-btn
                      flat round dense
                      :icon="props.inFullscreen ? 'fullscreen_exit' : 'fullscreen'"
                      @click="toggleFullscreen(props)"
                      class="q-ml-md"
                    />
                  </div>
                </template>              
                <template v-slot:body-cell-selected="props">
                  <q-td :props="props">
                    <q-checkbox v-model="props.row.selected" />
                  </q-td>
                </template>
                <template slot="header" slot-scope="props">
                  <q-tr>
                    <q-th :colspan="props.cols[0].detailsRows"></q-th>
                    <q-th :colspan="props.cols[0].notMatchRows" class="bg-red-14 text-white" v-if="props.cols[0].notMatchRows">{{props.cols[0].notMatchRows}}</q-th>
                    <q-th :colspan="props.cols[0].matchRows" class="bg-light-green-9 text-white" v-if="props.cols[0].matchRows">{{props.cols[0].matchRows}}</q-th>
                    <q-th :colspan="props.cols[0].newRows" class="bg-yellow-12" v-if="props.cols[0].newRows">{{props.cols[0].newRows}}</q-th>
                    <q-th :colspan="props.cols[0].additionalRows" class="bg-blue-12" v-if="props.cols[0].additionalRows">{{props.cols[0].additionalRows}}</q-th>
                  </q-tr>
                  <q-tr>
                    <q-th v-for="(col,index) in props.cols" v-if="col.name != 'metadata'" style="white-space: normal !important; width:50px" :key="index">
                      <template v-if="col.isColour">
                      <q-checkbox color="red" dense :value="selectAllState[col.name]" @input="v => selectAllColumn(v,col.name)"/>
                      </template>
                    </q-th>
                  </q-tr>
                  <q-tr>
                    <q-th v-for="(col,index) in props.cols" v-if="col.name != 'metadata'" style="white-space: normal !important" :key="index">
                      {{col.label}}
                    </q-th>
                  </q-tr>
                </template>
                <template slot="body-cell-metadata" slot-scope="props">
                  <q-td style="width:1px;padding:0;margin:0;display:none;">
                  </q-td>
                </template>
                <template :slot="`body-cell-${colourId}`" slot-scope="props"  v-for="(colour,colourId,index) in colourList">
                  <q-td :style="{'background-color': colour.hex ,'width': '20px', 'text-align': 'center'}" :key="index">
                    <q-tooltip anchor="center right" self="center left" :offset="[10, 10]"
                              transition-show="scale"
                              transition-hide="scale"
                              content-style="color:black; background: white; border: solid 1px black">{{colour.name}} - {{colour.group}} - {{colour.hex}} - {{colour.id}} ({{colour.manufacturer}})
                    </q-tooltip> 
                    <q-checkbox  color="red" dense v-model="productsGrid[props.row.reference][colourId].state" style="background-color:white;"  />
                  </q-td>
                </template>                     

              </q-table>
              <div class="row justify-end" style="margin:30px">
                <q-btn @click="gotoMatchedAttributesPanel" flat color="primary" label="Back" style="margin-right:20px"/>
                <q-btn color="primary" @click="updateAllproducts()" label="Update Products" class="q-ml-sm" :disable="disableOnUpdating"/>
              </div>
            </template>
            <q-inner-loading :showing="matchedProcessing" >
              <div style="padding:50px; background-color:white; border: solid 1px black; border-radius:30px" v-if="!matchedProcessingDone">
                <div class="text-center" style="font-weight: bold; padding:10px">Updating Products</div>
                <div class="text-center">
                  <q-spinner-gears size="100px" color="primary" style="margin:auto; padding:0px;"/>      
                </div>
                <br>
                <div class="text-center">
                  {{currentProductUpdating}}
                </div>
                <div class="text-center text-bold">
                  {{progress}}%
                </div>                                                   
              </div>
              <div style="padding:50px; background-color:white; border: solid 2px silver; border-radius:20px" v-if="matchedProcessingDone">
                <div style="font-weight: bold; padding:10px">Updated</div>
                <div class="text-center">
                  <q-icon color="green" name="done" size="50px" />     
                </div>
              </div>                  
            </q-inner-loading>    
          </q-tab-panel>

          <!-- New Products Panels -->
          <q-tab-panel name="notMatched">
            <template v-if="showNewProductsAttributesPanel">
              <q-table
                :style="{maxHeight: tableHeight }"
                :data="newProducts"
                :columns="columnsNewProducts()"
                :pagination="{rowsPerPage: 0}"
                binary-state-sort
                flat
                row-key="name" >
                <template v-slot:top="props">
                  <div class="row justify-end">
                  <div class="text-h6">{{newProducts.length}} New products</div>
                  <q-btn
                    flat round dense
                    :icon="props.inFullscreen ? 'fullscreen_exit' : 'fullscreen'"
                    @click="toggleFullscreen(props)"
                    class="q-ml-md"
                  />
                  </div>
                </template>                                      
              </q-table>
              <div class="row justify-end" style="margin:30px"> 
                <q-btn color="primary" @click="gotoNewProductsColourPanel" label="Next" class="q-ml-sm" :disable="newProducts.length == 0"/>
              </div>              
            </template>
            <template v-if="showNewProductsColourPanel && newProducts.length > 0">
              <q-table
                :style="{maxHeight: tableHeight }"
                :data="newProducts"
                :columns="columnsNewProductsColour()"
                :pagination="{rowsPerPage: 0}"
                binary-state-sort
                flat    
                row-key="reference" >
                <template v-slot:top="props">
                  <div class="row justify-end">
                  <div class="text-h6">Colour Mixer</div>
                  <q-btn
                    flat round dense
                    :icon="props.inFullscreen ? 'fullscreen_exit' : 'fullscreen'"
                    @click="toggleFullscreen(props)"
                    class="q-ml-md"
                  />
                  </div>
                </template>               
                <template v-slot:body-cell-selected="props">
                  <q-td :props="props">
                    <q-checkbox v-model="props.row.selected" />
                  </q-td>
                </template>
                <template slot="header" slot-scope="props">
                  <q-tr>
                    <q-th v-for="(col,index) in props.cols" v-if="col.name != 'metadata'" style="white-space: normal !important; width:80px" :key="index">
                      <template v-if="col.isColour">
                      <q-checkbox color="red" dense :value="selectAllStateNewProducts[col.name]" @input="v => selectAllColumnNewProducts(v,col.name)"/>
                      </template>
                    </q-th>
                  </q-tr>
                  <q-tr>
                      <q-th v-for="(col,index) in props.cols" style="white-space: normal !important" :key="index">
                          {{col.label}}
                      </q-th>
                  </q-tr>
                </template>
                <template slot="body-cell-metadata" slot-scope="props">
                <q-td style="width:1px;padding:0;margin:0;display:none;">
                </q-td>
                </template>
                <template :slot="`body-cell-${colourId}`" slot-scope="props" v-for="(colour,colourId,index) in colourListNewProducts">
                  <!-- <q-td :style="{...getColorGridStyle(colourCol.colourName), 'width': '20px', 'text-align': 'center'}" :key="colourCol.name"> -->
                  <q-td :style="{'background-color': colour.hex ,'width': '20px', 'text-align': 'center'}" :key="index">
                      <q-tooltip anchor="center right" self="center left" :offset="[10, 10]"
                                transition-show="scale"
                                transition-hide="scale"
                                content-style="color:black; background: white; border: solid 1px black">{{colour.name}} - {{colour.group}} - {{colour.hex}} - {{colour.id}} ({{colour.manufacturer}}
                      </q-tooltip>  
                      <q-checkbox  color="red" dense v-model="newProductsGrid[props.row.reference][colourId].state" style="background-color:white;"  />
                  </q-td>
                </template>                   
              </q-table>
              <div class="row justify-end" style="margin:30px">
                <q-btn @click="gotoNewProductsAttributesPanel" flat color="primary" label="Back" style="margin-right:20px"/>
                <q-btn color="primary" @click="saveNewProducts()" label="Add New Products" class="q-ml-sm" :disable="disableOnCreating"/>
              </div>              
            </template>
            <q-inner-loading :showing="newProductsProcessing" >
              <div style="padding:50px; background-color:white; border: solid 1px black; border-radius:30px" v-if="!newProductsProcessingDone">
                <div class="text-center" style="font-weight: bold; padding:10px">Creating Products</div>
                <div class="text-center">
                  <q-spinner-gears size="100px" color="primary" style="margin:auto; padding:0px;"/>      
                </div>
                <br>
                <div class="text-center">
                  {{currentProductCreating}}
                </div>
                <div class="text-center text-bold">
                  {{newProductsprogress}}%
                </div>                  
              </div>
              <div style="padding:50px; background-color:white; border: solid 2px silver; border-radius:20px" v-if="newProductsProcessingDone">
                <div style="font-weight: bold; padding:10px">Done</div>
                <div class="text-center">
                  <q-icon color="green" name="done" size="50px" />     
                </div>
              </div>                  
            </q-inner-loading>             
          </q-tab-panel>

          <q-tab-panel name="summary">
            <div class="text-h6">Summary</div>
            Stats about the Products and SKUS
          </q-tab-panel>
        </q-tab-panels>
      </div>
    </div>
  </div>
  </q-page>
</template>

<script>
/* eslint-disable */

import Excel from 'exceljs';
import _ from 'lodash';
import colString from 'excel-column-name';
// import { csv } from 'csvtojson'
import gql from 'graphql-tag'
// import * as levenshtien from 'damerau-levenshtein';
import { colourToString, formatCurrency, properCase } from '../../util/string'
import moment from 'moment'
import saveAs from 'file-saver'
import notifyMessage from '../../util/notifyMessage'
import notifyError from '../../util/adminNotifyError'

export default {
  name: 'PageAdminDashboard',
  data (){
      return {
        debug:false,
        notesList:{},
        selectAllFoundProducts: true,
        extraColours:[],
        selectedAdditionalColours:[],
        additionalColours:[],
        dataLoaded:false,
        filename:"",
        saveOFDataAs:"",
        saveOFNotes:"",
        selectedSavedOFData:"",
        savedOFDataList:[],
        newRevisionName:"",
        showNewRevisionDialog:false,
        revisions:[],
        revisionList:[],
        currentRevision:"",
        currentEditingRule:"",
        rulesResult:{},
        ruleID:0,
        rules:{},
        rulesToApply:[{step:0,rule:"replaceAll",input:[]}],
        rulesOptions : [ { id: 'replaceAll', desc: 'Replace All'},
          { id: 'replaceOnce', desc: 'Replace Once'},
          { id: 'replaceRegex', desc: 'Replace Regex'},
          { id: 'addToStart', desc: 'Add at the start'},
          { id: 'addToEnd', desc: 'Add at the end'},
          { id: 'splitByAndKeepFirst', desc: 'Split using term and keep first'},
          { id: 'splitByAndRemoveFirst', desc: 'Split using term and remove first'},
          { id: 'regexMatch', desc: 'Regex Match'},
          { id: 'camelCase', desc: 'Apply CamelCase to all text'},
          { id: 'upperCase', desc: 'Apply UpperCase to all text'},
          { id: 'lowerCase', desc: 'Apply LowerCase to all text'},
          { id: 'multiply', desc: 'Multiply By (Only for Price)'}
        ],        
        sampleInput:{},
        showRulesDialog:false,
        inputType:{
          name:"Range",
          reference:"Range",
          grip:"Range",
          holds:"Range",
          material:"Range",
          price:"Range",
          range:"Range",
          size:"Range",
          type:"Range",
        },
        constantAttributes:{},
        productsGrid:{},
        coloursOnlyInProducts:[],
        coloursInProductsAndOrderForm: [],
        coloursOnlyInOrderForm: [],
        referenceIndexList:[],
        disableSetPriceButton:true,
        fxrate:"",
        variation: 0.05,
        upsale: 2.2,
        surcharge: 5,
        progress: 0,
        progressLabel: "0%",
        newProductsprogress: 0,
        currentProductCreating: "",
        currentProductUpdating:"",
        matchedProcessing: false,
        matchedProcessingDone: false,
        newProductsProcessing: false,
        newProductsProcessingDone: false,
        disableOnUpdating:false,
        disableOnCreating:false,
        tableHeight: "500px",
        showMatchedAttributesPanel:true,
        showMatchedColourPanel: false,
        showNewProductsAttributesPanel:true,
        showNewProductsColourPanel: false,
        showLoadingPriceSelectorPage: true,
        showPriceSelectorPage: false,
        showColourSelectorPage: false,
        showLoadingColourSelectorPage: true,
        enableToStep2:false,
        showFileUploader:true,
        showSheetSelector: false,
        showAttributesList: false,
        enableAttributesNextButton: false,
        colourListNewProducts:{},
        newProductsGrid:{},
        selectAllStateNewProducts:{},
        renderThis: true,
        newColoursToProduct:[],
        selectAllState:{},
        selectedColourToSave: {},
        dropdownColourToSave: {},
        curatedColours:{},        
        coloursProcessed: false,
        allColours:undefined,
        sheets:[],
        sheetsLoaded: false,
        sheetSelected: '',
        workbook: undefined,
        worksheet: undefined,
        sheetName: undefined,
        hiddenRows: [],
        productsGeneratedFromOrderForm:'',
        attributeID:1,
        attributes:[{id:0,name:"colour",range:"",addAttribute:false},{id:1,name:"name",range:"",addAttribute:true}],
        attributes2:{
          "colour":{id:0,range:"",addAttribute:false},
          "name":{id:1,range:"",addAttribute:true},
          "grip":{id:2,range:"",addAttribute:true},
          "holds":{id:3,range:"",addAttribute:true},
          "price":{id:4,range:"",addAttribute:true},
          "range":{id:5,range:"",addAttribute:true},
          "reference":{id:6,range:"",addAttribute:true},
          "size":{id:7,range:"",addAttribute:true},
          "type":{id:8,range:"",addAttribute:true}
        },
        attributeAsReference:1,
        dataRanges : {},
        selectionOfAttributes : [],
        tableHeaders : [],
        referenceAttribute : '',
        fileProcess:{status:"Loading",loading:false,errorMessage:""},
        productsCSV:'_',
        productsFromDB:'',
        step: 1,
        allDone: false,
        foundProducts: [],
        panel: 'matched',
        newProducts: [],
        hiperlinksList:{},
        attributesOptions : [ { id: 'name', desc: 'Name', inactive: false },
          { id: 'grip', desc: 'Grip', inactive: false },
          { id: 'holds', desc: ' # Holds', inactive: false },                      
          { id: 'price', desc: 'Price', inactive: false },
          { id: 'range', desc: 'Range', inactive: false },              
          { id: 'reference', desc: 'Reference', inactive: false },    
          { id: 'size', desc: 'Size', inactive: false },
          { id: 'type', desc: 'Type', inactive: false },                              
        ],
        productTemplate : {
          name: '',
          price: 0,
          newContainerPrice: 0,
          urlSlug: '',
          description:'',
          reference: '',
          manufacturer: '',
          type: '',
          brand: '',
          range: '',
          grip: '',
          material: '',
          size: '',
          holds: '', 
          colours:[]
        },
        // colourList:["#bf0610","#3b66ff","#ff9400","#008381","#890083","#5ed432","#cda0e8","#fdb400","#009c62","#000000","#ffffff"],
        colourList:{},
        colourGrid:{},
        orderFormColoursMatched:{},
        d:undefined,
        //NEW VARIABLES FOR ATTRIBUTE INPUTS
        productManufacturer:"",
        productBrand:"",
        productMaterial:"",
        productDetailsList:{
            "360":{
              "360":["PU","Fiberglass"],
              "Simpl":["Wood"]},
            "Aragon":{
              "Flathold":["PU"], 
              "Grizzly":["PU"],
              "Kilter":["PU"],
              "Kingdom":["PU"],
              "Urban Plastix":["PU"],
              "Working Class":["PU"]},
            "BlocSyndicate":{
              "Satellite":["PU"]},
            "Composite X":{
              "AIX":["Fiberglass","PE","PU","Wood"], 
              "Cheeta":["Dannomond","Fiberglass","Wood"], 
              "Flathold":["Dannomond","Fiberglass"], 
              "Kilter":["Dannomond"], 
              "Kingdom":["Dannomond"], 
              "Urban Plastix":["Dannomond"], 
              "Walltopia":["Fiberglass"], 
              "Working Class":["PE"]},
            "Dimension":{
              "Dimension":["Wood"]},
            "Tack Composites":{
              "Elevation":["Fiberglass"]},
            "Tension":{
              "Tension":["Wood"]},
            "Under Blue Hold":{
              "Under Blue Hold":["Dannomond","Wood"]}
        },
        atributesDataValues:[],
        coloursMatched:{}
    }
  },
  computed: {
    validateInputs(){
      if(this.productManufacturer != "" && 
         this.productBrand != "" && 
         this.productMaterial != "" &&
         this.attributes2.colour.range != "" &&
         this.attributes2.name.range != "" &&
         this.attributes2.reference.range != "" &&
         this.attributes2.price.range != ""
         ){
        return false
      }else
        return true
    },
    validateInputsForSave(){
      if(this.productManufacturer != "" && 
         this.productBrand != "" && 
         this.productMaterial != "" &&
         this.attributes2.colour.range != "" &&
         this.attributes2.name.range != "" &&
         this.attributes2.reference.range != "" &&
         this.attributes2.price.range != "" &&
         this.saveOFDataAs != "" &&
         this.filename != "" &&
         this.sheetSelected != ""
         ){
        return false
      }else
        return true
    },    
    currentAccount () {
      return this.$store.state.auth.currentAccount
    },
    getAttributes (){
        return this.attributes;
    },
    verifyColourSelection(){
      let actionsrequired = 0;
      for(let key in this.coloursMatched){
        if(this.coloursMatched[key].length >1){
          actionsrequired++
        }
      }  

      if(Object.keys(this.selectedColourToSave).length == actionsrequired){
        return false
      }else{
        return true
      }
    },    
  },
  methods: {
    moment:moment,
    setFilename(filename){
      this.filename = filename;
      return filename
    },
    selectAllFound(){
      this.selectAllFoundProducts =  !this.selectAllFoundProducts
      for(let product of this.foundProducts){
        product.selected = !this.selectAllFoundProducts
      }
    },
    async getAdditionalColours(){
      this.additionalColours =  await this.coloursByAttrbutes(this.productManufacturer,"All",this.productMaterial)
    },
    async coloursByAttrbutes(manufacturer,brand,material){
      let input = {manufacturer:manufacturer,brand:brand,material:material}
      try {
        const result = await this.$apollo.query({
          query: gql`query coloursByAttrbutes ($input: colourDetails!) {
            coloursByAttrbutes(input: $input){
              id
              name
              supergroup
              group
              hex
              legacyColour
              manufacturer
              brand
              material
              notes
              updatedAt
              createdAt   
            }
          }
        `,
        variables:{
          input:input
        },
        fetchPolicy: 'network-only'
        })
        console.log('coloursByAttrbutes',result.data.coloursByAttrbutes);
        
        return result.data.coloursByAttrbutes;
      } catch (error) {
        console.log("coloursByAttrbutes Error:", error)
        throw new Error(error);    
      }         
    },      
    async createSKULocation(input){ 
      const result = await this.$apollo.mutate({
        mutation: gql`mutation createSkuLocation($input: SkuMapInput!){
          createSkuLocation(input:$input){
            id
            skuId
            colour
            location
            manufacturer
            brand
            orderForm
            sheet
            }
        }`,
        variables: {
          input: input,
        }
      })
      console.log(result.data.createSkuLocation)
      return result.data.createSkuLocation
    },        
    async createSavedOFData(){
      let attributes = _.cloneDeep(this.attributes2)
      attributes.manufacturer = this.productManufacturer
      attributes.brand = this.productBrand
      attributes.material = this.productMaterial
      attributes.attributeAsReference = this.attributeAsReference
      attributes.rules = this.rules

      try {
        let input = {
          name:this.saveOFDataAs,
          notes:this.saveOFNotes,
          filename:this.filename,
          sheet:this.sheetSelected,
          attributes: attributes,
          rev: this.currentRevision.rev
        }

        const result = await this.$apollo.mutate({
          mutation: gql`mutation createSavedOFData($input: SavedOFDataInput) {
            createSavedOFData(input:$input){
              id
              name
              notes
              filename
              sheet
              attributes
              rev
              createdAt
              updatedAt
            }
          }
        `,
        variables:{
          input:input
        }
        })
        notifyMessage(this.$q,"Attributes Ranges Saved",this.saveOFDataAs);        
        return result.data.createSavedOFData;
      } catch (error) {
        console.log("createSavedOFData Error:", error)
        throw new Error(error);    
      }       
    },       
    async loadSavedData(){
      let savedData = await this.getAllSavedOFData()
      savedData.forEach(saved=>{saved.label=`${saved.name} - ${moment(saved.createdAt).format("DD/MMM/YY HH:mm:ss")}`; saved.value=saved.id})
      this.savedOFDataList = savedData
    },
    async getAllSavedOFData(){
      try {
        const result = await this.$apollo.query({
          query: gql`query getAllSavedOFData {
            getAllSavedOFData{
              id
              name
              notes
              filename
              sheet
              attributes
              rev
              createdAt
              updatedAt
            }
          }
        `,
        fetchPolicy: 'network-only'
        })
        console.log('getAllSavedOFData',result.data.getAllSavedOFData);
        
        return result.data.getAllSavedOFData;
      } catch (error) {
        console.log("getAllSavedOFData Error:", error)
        throw new Error(error);    
      }       
    },    
    async createNewRevision(){
      try{
        let newRevision = await this.createRevision(this.newRevisionName)
        await this.setRevisions()
        notifyMessage(this.$q,"New Revision Created","Successfully");
      }catch(e){
        notifyError(this.$q,"Error creating revision",e)
      }
    },
    async createRevision(name){     
      try {
        const result = await this.$apollo.mutate({
          mutation: gql`mutation createProductRevision($name: String!) {
            createProductRevision(name:$name){
              id
              name
              rev
              createdAt
              updatedAt
            }
          }
        `,
        variables:{
          name:name
        }
        })
        console.log('createProductRevision',result.data.createProductRevision);
        return result.data.createProductRevision;
      } catch (error) {
        console.log("createProductRevision Error:", error)
        throw new Error(error);    
      }       
    },        
    async newRevisionDialog(){
      this.showNewRevisionDialog = true
    },
    async setRevisions(){
      let revisions = await this.getRevisions()
      revisions.forEach(r=>{r.label=`Rev. ${r.rev} | ${r.name} | ${moment(r.createdAt).format("DD/MMM/YY HH:mm:ss")}`; r.value=r.rev})
      this.revisionList = revisions
      this.currentRevision = revisions[0] 
    },
    loadRevisions(){
      let revisions = []
      for(let rev of this.revisions){
        revisions.push(rev.rev)
      }
      return revisions
    },
    async getRevisions(){
      try {
        const result = await this.$apollo.query({
          query: gql`query productRevisions {
            productRevisions{
              id
              name
              rev
              createdAt
              updatedAt
            }
          }
        `,
        fetchPolicy: 'network-only'
        })
        console.log('productRevisions',result.data.productRevisions);
        
        return result.data.productRevisions;
      } catch (error) {
        console.log("productRevisions Error:", error)
        throw new Error(error);    
      }       
    },    
    async getRevision(){
      try {
        const result = await this.$apollo.query({
          query: gql`query productRevision {
            productRevision{
              id
              name
              rev
              createdAt
              updatedAt
            }
          }
        `,
        fetchPolicy: 'network-only'
        })
        console.log('productRevision',result.data.productRevision);
        
        return result.data.productRevision;
      } catch (error) {
        console.log("productRevision Error:", error)
        throw new Error(error);    
      }       
    },    
    async applyRulesOnDialog(attribute){
      let rules = this.rules[attribute]
      let input = this.sampleInput[attribute]
      this.rulesResult[attribute] = await this.evaluateRules(input,rules)
    },    
    async evaluateRules(input,rules){
      console.log('RULES',this.rules);

      function multiply(arg1){
        input = Number(input) * Number(arg1)
      }

      function upperCase(){
        input = input.toUpperCase()
      }

      function lowerCase(){
        input = input.toLowerCase()
      }
      
      function camelCase(){
        input = properCase(input)
      }

      function regexMatch(arg1){
        console.log('REGEXMACTCH','arg1');
        console.log('INPUT',input);
        
        
         let result = input.match(eval(arg1)) || []
         console.log('RESULT',result);
         
         if(result.length){
           input = result[0]
         }
      }         
      function splitByAndKeepFirst(arg1){
         let terms = input.split(arg1)
         input = terms[0] 
      }
      function splitByAndRemoveFirst(arg1){
         let terms = input.split(arg1)
         if(terms.length > 1){
            terms.shift()
         }
         input = terms.join(arg1) 
      }        
      function replaceRegex(arg1,arg2){
        console.log('replaceRegex',arg1,arg2);   
        input = input.replace(eval(arg1),arg2)
      }

      function replaceAll(arg1,arg2){ 
        console.log('replaceAll',arg1,arg2);   
        // input = input.replace(new RegExp(arg1,"g"),arg2)
        input = input.split(arg1).join(arg2);
      }

      function replaceOnce(arg1,arg2){
        console.log('replaceOnce',arg1,arg2);
        input = input.replace(arg1,arg2)
      }

      function addToStart(arg1){
        input = arg1+input
      }

      function addToEnd(arg1){
        input = input+arg1
      }

      for(let ruleData of rules){
        eval(`${ruleData.rule}('${ruleData.input[0]||""}','${ruleData.input[1]||""}','${ruleData.input[2]||""}','${ruleData.input[3]||""}')`)
      }
      return input
    },
    async addRule(attribute){ 
      console.log('this.rules[attribute]',this.rules[attribute].step);
          
        let nextStep =  this.rules[attribute][this.rules[attribute].length - 1].step

        this.rules[attribute].push({step:nextStep + 1,rule:"replaceAll",input:[]});
        // this.$set(this.rules,attribute,[{step:nextStep+1,rule:"replaceAll",input:[]}])
    },    
		async rulesDialog(attribute){
      if(!this.rules[attribute]){
        this.$set(this.rules,attribute,[{step:0,rule:"replaceAll",input:[]}])
        this.$set(this.rulesResult,attribute,"")
        this.$set(this.sampleInput,attribute,"")
      }
      this.currentEditingRule = attribute;
			this.showRulesDialog = true
      console.log('RULESSS',this.rules);
		},    
    myRule (val) {
      if (!val) {
        return 'Required'         
      }
    },
    getBrandsByManufacturer(manufacturer){
      if(manufacturer)
        return this.brandsList[manufacturer]
      else
        return []
    },
    //Single colour as String or Array of Colours as Strings, return ARRAY of colours
    async matchColours(coloursToMatch,manufacturer,brand,material=undefined){
      let colours = []
      if(typeof colours == "string"){
        colours.push(coloursToMatch)
      }else{
        colours = coloursToMatch;
      }

      let details = {
        rawColours: colours,
        manufacturer: manufacturer,
        brand:brand
      }

      if(material){
        details.material = material
      }

      try {
        const result = await this.$apollo.query({
          query: gql`query matchColours ($input: MatchDetails!) {
            matchColours (input:$input)
          }
        `,
        variables: {
          input: details
        },
        fetchPolicy: 'network-only'
        })
        console.log('matchColours',result.data.matchColours);
        
        return JSON.stringify(result.data.matchColours);
      } catch (error) {
        console.log("matchColours Error:", error)
        throw new Error(error);    
      }      

    },
    checkInputs(){
      console.log(this.fxrate,!isNaN(this.fxrate))
      if(!isNaN(this.fxrate) && this.fxrate.trim() && this.fxrate >= 0 && !isNaN(this.variation) && this.variation >= 0  && this.variation){
        this.disableSetPriceButton = false
      }else{
        this.disableSetPriceButton = true
      }
    },
    getNewPrice(originalPrice){
      let price = Number(originalPrice);
      let fxrate = Number(this.fxrate) || 0;
      let variation = Number(this.variation) || 0;
      let upsale = Number(this.upsale) || 0;
      let surcharge = Number(this.surcharge) || 0;

      let calculatedFXPrice = price * ( fxrate + variation )
      let calculatedWithUpsale = calculatedFXPrice * upsale
      // let calculatedWithColourSurcharge = ( price * ( 1 + (surcharge/100)) ) * ( fxrate + variation );
      return({
        calculatedFXPrice:calculatedFXPrice,
        calculatedWithUpsale:calculatedWithUpsale,
        // calculatedWithColourSurcharge:calculatedWithColourSurcharge
        })
    },
    toggleFullscreen(props){
      if(props.inFullscreen){
        this.tableHeight = "500px"
      }else{
        this.tableHeight = "100%"
      }
      props.toggleFullscreen()
    },
    setTableHeight(){
      this.tableHeight = "100%"
    },
    gotoMatchedColourPanel(){
      this.showMatchedAttributesPanel =false
      this.showMatchedColourPanel = true
      window.scrollTo(0, 0)
    },
    gotoMatchedAttributesPanel(){
      this.showMatchedAttributesPanel = true
      this. showMatchedColourPanel = false
      window.scrollTo(0, 0)
    },
    gotoNewProductsColourPanel(){
      this.showNewProductsAttributesPanel =false
      this.showNewProductsColourPanel = true
      window.scrollTo(0, 0)
    },
    gotoNewProductsAttributesPanel(){
      this.showNewProductsAttributesPanel = true
      this. showNewProductsColourPanel = false
      window.scrollTo(0, 0)
    },    
    async saveNewProducts (){
      let linksToFile = [];
      let hasLinks = false;
      this.newProductsProcessing = true;
      let done = []
      let errors = []
      let count = 0;
      let manufacturer,brand,material;
   
      for(let product of this.newProducts){
        count++;
        this.newProductsprogress = Number(((count/this.newProducts.length) * 100).toFixed(2))
        this.currentProductCreating = product.name
        let results;
        let processResult = []
  
        if(product.selected){
          let prodTemplate = {
            "name": product?.name || '',
            "description": product?.description || '',
            "reference": product?.reference || '',
            "urlSlug": 'update-this',
            "images": [],
            "rev": this.currentRevision.rev,
            "attributes": {
              "manufacturer": product?.attributes?.manufacturer || '',
              "type":  product?.attributes?.type || '',
              "brand":  product?.attributes?.brand || '',
              "range":  product?.attributes?.range || '',
              "grip":  product?.attributes?.grip || '',
              "material":  product?.attributes?.material || '',
              "size":  product?.attributes?.size || '',
              "holds":  product?.attributes?.holds || '',
              "bolts": '[]',
              "screws": '[]',
            }
          }
          let newID = await this.addNewProduct(prodTemplate)
          await this.sleep(10)

          let grid = this.newProductsGrid[product.reference]
          let colourLocation = undefined

          for(let colourId in grid){
            if(grid[colourId].state){
              console.log("ID:",newID)
              let skuTemplate = {
                "productId": newID,
                "colour":'',
                "price": 0,
                "stock": 0,
                "barcode": "",
                "containerPrice": 9999999,
                "retailPrice": 0,
                "showInContainer": true,
                "showInRetail": false,
                "hideInStock": true,      
                "options": {
                  // colour: JSON.stringify({ 'name': '07-13', 'superGroup': 'Purple', 'group': 'Purple', 'hex': '#800f7f' })
                  "colour": ""
                }
              }
              
              for(let colour of product.colours){
                if(colour.id == colourId){
                  colourLocation = colour.cellLocation;
                }
              }

              skuTemplate.containerPrice = product.newContainerPrice
              skuTemplate.colour = colourId
              skuTemplate.options.colour = this.colourList[colourId].legacyColour;
              let newSku = await this.addSku(skuTemplate)
              console.log("SKU ADDED")
              await this.sleep(100)
              if(colourLocation){
                let skuMapDetails = {
                  skuId:newSku.id,
                  colour:colourId,
                  location:colourLocation,
                  manufacturer:this.productManufacturer,
                  brand:this.productBrand,
                  orderForm:this.filename,
                  sheet:this.sheetSelected,
                  rev:this.currentRevision.rev
                }
                await this.createSKULocation(skuMapDetails)
                await this.sleep(100)                
              }
            }
          }
          
          if(product.hyperlinks.length){
            linksToFile.push({id:newID,links:product.hyperlinks,product:prodTemplate})
          }

          if(!manufacturer && !brand && !material){
            manufacturer = prodTemplate.attributes.manufacturer
            brand = prodTemplate.attributes.brand
            material = prodTemplate.attributes.material
          }   
        }
        try{
          results = await Promise.all(processResult); //you can use promise chaining here too
        } catch(e){
          console.log(e);
        }    
      }
      try {
        let now = moment().format('DDMMYY_hh:mm:ss')
        let filename = `${manufacturer}_${brand}_${material}_${now}.json`
        saveAs(new Blob([ JSON.stringify(linksToFile, null, "\t")], { type: 'application/octet-stream' }), filename.replace(/\s+/g, ''))
      } catch (exception) {
        console.log(exception)
      }      
      this.newProductsProcessingDone = true;
    },
    sleep(time) {
      console.log("sleeping for: ", time)
      return new Promise((resolve) => setTimeout(resolve, time))
    },
    async softDeleteSKU (id) {
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation softDeleteSku($id: ID!) {
                softDeleteSku (id: $id)
            }
          `,
          variables: {
            id: id
          }
        })
        console.log(id,"Deleted:",response.data.softDeleteSku)
        return response.data.softDeleteSku.id;
      } catch (error) {
        console.log('Error deleting SKU',error);
        
      }
    },    
    async updateAllproducts(){
      this.matchedProcessing = true;
      //contadores
      let done = []
      let errors = []
      let count = 0;
      
      for(let product of this.foundProducts){

        count++;
        this.progress = Number(((count/this.foundProducts.length) * 100).toFixed(2))
        this.currentProductUpdating = product.name
        let results;
        let processResult = []
        if(product.selected){
          if(Object.keys(product?.differences).length > 0){
            let prodTemplate = {
              "name": product?.differences?.name?.new || product?.name || '',
              "description": product?.differences?.description?.new || product?.description || '',
              "reference": product?.differences?.reference?.new || product?.reference || '',
              "rev":this.currentRevision.rev,
              "attributes": {
                "manufacturer": product?.differences?.manufacturer?.new || product?.attributes?.manufacturer || '',
                "type":  product?.differences?.type?.new || product?.attributes?.type || '',  
                "brand":  product?.differences?.brand?.new || product?.attributes?.brand || '',
                "range":  product?.differences?.range?.new || product?.attributes?.range || '',
                "grip":  product?.differences?.grip?.new || product?.attributes?.grip || '',
                "material":  product?.differences?.material?.new || product?.attributes?.material || '',
                "size":  product?.differences?.size?.new || product?.attributes?.size || '',
                "holds":  product?.differences?.holds?.new || product?.attributes?.holds || ''
              }
            }
            let editedProduct = await this.editProduct(product.id,prodTemplate);
            processResult.push(editedProduct.id);
            await this.sleep(10)
          }

          let skuTemplate = {
            "productId": product.id,
            "colour": "",
            "price": 0,
            "stock": 0,
            "barcode": "",
            "containerPrice": product.newContainerPrice,
            "retailPrice": 0,
            "showInContainer": '',
            "showInRetail": false,
            "hideInStock": true,      
            "options": {
              // colour: JSON.stringify({ 'name': '07-13', 'superGroup': 'Purple', 'group': 'Purple', 'hex': '#800f7f' })
              "colour": ""
            }
          }

          let grid = this.productsGrid[product.reference]
          let colourLocation = undefined

          for(let colourId in grid){
            
            let originalData = grid[colourId].originalData

            for(let colour of product.colours){
              if(colour.id == colourId){
                colourLocation = colour.cellLocation;
              }
            }

            //Si el producto tiene OriginalData
            if(originalData){
              if(originalData.state == true && grid[colourId].state == false){
                //Delete SKU
                console.log('DELETE SKU',product.name,this.colourList[colourId].name);
                await this.editSku(originalData.skuId, {showInContainer:false})                
                await this.softDeleteSKU(originalData.skuId)
                await this.sleep(10)  
              }else if(originalData.state == true & grid[colourId].state == true){
                //UPDATE sku
                console.log('UPDATE SKU',product.name,this.colourList[colourId].name);
                let editedSKU = await this.editSku(originalData.skuId, {containerPrice:product.newContainerPrice,showInContainer:grid[colourId].showInContainer,options:{colour:this.colourList[colourId].legacyColour}})
                processResult.push(editedSKU);
                await this.sleep(10)
                if(colourLocation){
                  let skuMapDetails = {
                    skuId:originalData.skuId,
                    colour:colourId,
                    location:colourLocation,
                    manufacturer:this.productManufacturer,
                    brand:this.productBrand,
                    orderForm:this.filename,
                    sheet:this.sheetSelected,
                    rev:this.currentRevision.rev
                  }
                  await this.createSKULocation(skuMapDetails)
                }
              }
            }else{
              if(grid[colourId].state == true){
                //CREATE NEW
                console.log('CREATE SKU',product.name,this.colourList[colourId].name);
                skuTemplate.showInContainer = grid[colourId].showInContainer
                skuTemplate.colour = colourId
                skuTemplate.options.colour = this.colourList[colourId].legacyColour;
                let addedSKU = await this.addSku (skuTemplate);
                processResult.push(addedSKU);
                await this.sleep(10)
                if(colourLocation){
                  let skuMapDetails = {
                    skuId:addedSKU.id,
                    colour:colourId,
                    location:colourLocation,
                    manufacturer:this.productManufacturer,
                    brand:this.productBrand,
                    orderForm:this.filename,
                    sheet:this.sheetSelected,
                    rev:this.currentRevision.rev
                  }
                  await this.createSKULocation(skuMapDetails)
                }                
              }
            }
          }
        }
        try{
          results = await Promise.all(processResult); //you can use promise chaining here too
        } catch(e){
          console.log(e);
        }     

      }
      this.matchedProcessingDone = true;
    },
    forceRerender() {
      // Remove my-component from the DOM
      this.renderThis = false;
      this.$nextTick(() => {
        // Add the component back in
        this.renderThis = true;
      });
    },    
    discard_changes(props,row,name){
      this.foundProducts.forEach(p => {
        if(p.reference == props.key){
          delete p.differences[name]
          this.forceRerender()
          return
        }
      })
    },
    async addNewProduct (input) {
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation addProduct($input: ProductInput!) {
                addProduct (input: $input) {
                    id
                }
            }
          `,
          variables: {
            input: input
          }
        })
        console.log("NEW PRODUCT ADDED:",response.data.addProduct)
        return response.data.addProduct.id;
      } catch (error) {
        console.log('ERROR CREATING NEW PRODUCT',error);
        
      }
    },

    async editProduct (productID,inputData) {
      try {
        const result = await this.$apollo.mutate({
          mutation: gql`mutation editProduct ($id: ID!, $input: ProductInput!) {
            editProduct(id: $id, input: $input) {
              id
              name
              description
              reference
              images {
                url
                name
              }
              attributes
              urlSlug
              skus {
                id
                attributes
                barcode
                options
                price
                containerPrice
                retailPrice
                showInRetail
                showInContainer
                hideInStock
                stock
              }
            }
          }
        `,
          variables: {
            id: productID,
            input: inputData
          }
        })
        console.log("EDIT PRODUCT RESULT:",result.data.editProduct)
        // this.newImageDialogShowing = false
        return result.data.editProduct;
      } catch (error) {
        console.log("EDIT ERROR", error)
      }
    },

    async editSku (skuID, changes) {
      // {"operationName":"editSku","variables":{"id":"5de9a8e5017f7816e4052045","input":{"stock":1}},"query":"mutation editSku($id: ID!, $input: SkuInput!) {\n  editSku(id: $id, input: $input) {\n    id\n    stock\n    __typename\n  }\n}\n"}1
      
      try {
        const result = await this.$apollo.mutate({
          mutation: gql`mutation editSku ($id: ID!, $input: SkuInput!) {
            editSku(id: $id, input: $input) {
              id
              colour
              attributes
              barcode
              options
              price
              containerPrice
              retailPrice
              showInContainer
              showInRetail
              hideInStock
              stock
            }
          }
        `,
          variables: {
            id: skuID,
            input: changes
          }
        })
        console.log("SKU EDIT RESULT:",result.data.editSku)
        return result.data.editSku;
      } catch (error) {
        console.log("UPDATING SKU ERROR",error)
      }
    },

    async addSku (input) {
      try {
        let result = await this.$apollo.mutate({
          mutation: gql`
            mutation addSku($input: SkuInput!) {
              addSku (input: $input) { 
                id
                colour
                attributes
                barcode
                options
                price
                containerPrice
                retailPrice
                showInContainer
                showInRetail
                hideInStock
                stock                 
              }
            }
          `,
          variables: {
            input
          }
        })
        console.log("RSULT FOR ADD SKU:",result.data.addSku)
        return result.data.addSku;
      } catch (error) {
        console.log("ERROR ADDING NEW SKU",error)
      }
    },

    showSelected (){
      console.log('SELECTED', this.selectedColourToSave);    
      console.log("DROP",this.dropdownColourToSave);
      
    },
    findAllMatches(counts,n,colour){
      let found = false
      for(let k in counts){
        if(counts[k] == n){
          this.orderFormColoursMatched[colour].push(k)
          found = true
        }
      }
      if(!found && n > 1){
        this.findAllMatches(counts,n-1,colour)
      }
    },    
    selectAllColumn(value,colourId,){
      this.selectAllState[colourId] = value
      for(let reference in this.productsGrid){
        if(this.productsGrid[reference][colourId].state != undefined){
          console.log(reference," - ", colourId, "from",this.productsGrid[reference][colourId].state,"to",value)
          this.productsGrid[reference][colourId].state = value
        }
      }
      console.log("GRID",this.productsGrid)
    },
    selectAllColumnNewProducts(value,colourId,){
      this.selectAllStateNewProducts[colourId] = value
      for(let reference in this.newProductsGrid){
        if(this.newProductsGrid[reference][colourId].state != undefined){
          this.newProductsGrid[reference][colourId].state = value
        }
      }
    },            
    columnsColour (){
      let columns = [
        { name: 'metadata', required: false, label: '', align: 'left', field: '', sortable: true, isColour: false, detailsRows:2,notMatchRows:this.coloursOnlyInProducts.length,matchRows:this.coloursInProductsAndOrderForm.length,newRows:this.coloursOnlyInOrderForm.length,additionalRows:this.extraColours.length },          
        { name: 'name', required: false, label: 'Name', align: 'left', field: row => row?.name, sortable: true, isColour: false },
        { name: 'reference', required: false, label: 'Reference',  align: 'left', field: row => row?.reference, sortable: true, isColour: false },  
      ]

      console.log("####################################### COLOUR LIST",this.colourList)

      for(let colourId of this.coloursOnlyInProducts){
        columns.push({ name: colourId, required: false, label: this.colourList[colourId].name,  align: 'center', field: "", sortable: false, match: false, isColour: true})
      }

      for(let colourId of this.coloursInProductsAndOrderForm){
        columns.push({ name: colourId, required: false, label: this.colourList[colourId].name,  align: 'center', field: "", sortable: false, match: true, isColour: true})
      }

      for(let colourId of this.coloursOnlyInOrderForm){
        columns.push({ name: colourId, required: false, label: this.colourList[colourId].name,  align: 'center', field:"", sortable: false, match: false, isColour: true, isNew: true})
      }
      
      for(let colourId of this.extraColours){
        columns.push({ name: colourId, required: false, label: this.colourList[colourId].name,  align: 'center', field:"", sortable: false, match: false, isColour: true, isNew: true})
      }         

      console.log("columnsdata",columns)

      return columns
    },
    findColour(row,colourId){
    if(!this.colourGrid[row.reference][colourId])
      this.$set(this.colourGrid[row.reference],colourId,false)
    },
    setColours(){
      for(let colour in this.coloursMatched){
        if(this.selectedColourToSave[colour]){
          this.curatedColours[colour] = _.cloneDeep(this.selectedColourToSave[colour])
        }else{
          this.curatedColours[colour] = _.cloneDeep(this.coloursMatched[colour][0])
        }
      }
      
      for(let key in this.attributesDataValues['colour']){
        if(key != 'ref'){
          let colour = this.attributesDataValues['colour'][key]
          let curatedColour = this.curatedColours[colour.value]
          colour.name = curatedColour.name
          colour.group = curatedColour.group
          colour.supergroup = curatedColour.supergroup
          colour.hex = curatedColour.hex
          colour.id = curatedColour._id
          colour.legacyColour = curatedColour.legacyColour
          colour.inForm = curatedColour.inForm
        }
      }
      // this.showColourSelectorPage = false;
      console.log("curatedColours",this.curatedColours)
      console.log('updated datavlue color',this.attributesDataValues['colour']);
      window.scrollTo(0, 0)
      this.showLoadingPriceSelectorPage = false
      this.showPriceSelectorPage = true
      // this.secondStepProcess()
    },       
    columnsNewProducts (){
        return [
        { name: 'selected', required: false, label: 'Added', align: 'left', field: row => row.selected, sortable: true },
        { name: 'key', required: false, label: 'Key', align: 'left', field: row => row.key, sortable: true },                     
        { name: 'brand', required: false, label: 'Brand', align: 'left', field: row => row?.attributes?.brand, sortable: true },
        { name: 'name', required: false, label: 'Name', align: 'left', field: row => row?.name, sortable: true },
        { name: 'reference', required: false, label: 'Reference',  align: 'left', field: row => row?.reference, sortable: true },
        { name: 'newPrice', required: false, label: 'New Price', align: 'left', field: row => formatCurrency(row.newContainerPrice), sortable: true, style:"font-weight:bold;background-color:#f0ffeb"},                        
        { name: 'manufacturer', required: false, label: 'Manufacturer', align: 'left', field: row => row?.attributes?.manufacturer, sortable: true },
        { name: 'range', required: false, label: 'Range', align: 'left', field: row => row?.attributes?.range, sortable: true },
        { name: 'type', required: false, label: 'Type', align: 'left', field: row => row?.attributes?.type, sortable: true },
        { name: 'material', required: false, label: 'Material', align: 'left', field: row => row?.attributes?.material, sortable: true },
        { name: 'size', required: false, label: 'Size', align: 'left', field: row => row?.attributes?.size, sortable: true },
        { name: 'grip', required: false, label: 'Grip', align: 'left', field: row => row?.attributes?.grip, sortable: true },
        { name: 'holds', required: false, label: 'Holds', align: 'left', field: row => row?.attributes?.holds, sortable: true },
     ]
    }, 
    columnsNewProductsColour (){
      let columns = []

      for(let formColour in this.curatedColours){
        let colourId = this.curatedColours[formColour]._id
        columns.push({ name: colourId, required: false, label: this.colourList[colourId].name,  align: 'center', field: "" , sortable: false, isColour: true})
      }

      for(let colour of this.selectedAdditionalColours){
        let colourId = colour.id
        columns.push({ name: colourId, required: false, label: `${this.colourList[colourId].name}\n(Additional)`, align: 'center', field: "" , sortable: false, isColour: true})
      }      

      let preDefCols = [
        { name: 'name', required: false, label: 'Name', align: 'left', field: row => row?.name, sortable: true, isColour: false },
        { name: 'reference', required: false, label: 'Reference',  align: 'left', field: row => row?.reference, sortable: true, isColour: false },  
      ]
      let newColumns = preDefCols.concat(columns)

      return newColumns
    },       
    columns (){
        return [
        { name: 'selected', required: false, label: 'Added', align: 'left', field: row => row.selected, sortable: true },
        { name: 'key', required: false, label: 'Key', align: 'left', field: row => row.key, sortable: true },        
        { name: 'brand', required: false, label: 'Brand', align: 'left', field: row => row.attributes.brand, sortable: true },
        { name: 'name', required: false, label: 'Name', align: 'left', field: row => row.name, sortable: true },
        { name: 'reference', required: false, label: 'Reference',  align: 'left', field: row => row.reference, sortable: true },                
        { name: 'manufacturer', required: false, label: 'Manufacturer', align: 'left', field: row => row.attributes.manufacturer, sortable: true },
        { name: 'range', required: false, label: 'Range', align: 'left', field: row => row.attributes.range, sortable: true },
        { name: 'type', required: false, label: 'Type', align: 'left', field: row => row.attributes.type, sortable: true },
        { name: 'material', required: false, label: 'Material', align: 'left', field: row => row.attributes.material, sortable: true },
        { name: 'size', required: false, label: 'Size', align: 'left', field: row => row.attributes.size, sortable: true },
        { name: 'grip', required: false, label: 'Grip', align: 'left', field: row => row.attributes.grip, sortable: true },
        { name: 'holds', required: false, label: 'Holds', align: 'left', field: row => row.attributes.holds, sortable: true },
        { name: 'price', required: false, label: 'Current Price', align: 'right', field: row => row.containerPriceRange.isRange ? `${formatCurrency(row.containerPriceRange.min)} - ${formatCurrency(row.containerPriceRange.max)}` : formatCurrency(row.containerPriceRange.string), sortable: true },
        { name: 'newPrice', required: false, label: 'New Price', align: 'left', field: row => formatCurrency(row.newContainerPrice), sortable: true, style:"font-weight:bold;background-color:#f0ffeb"},
        { name: 'change', required: false, label: 'Change', align: 'left', field: row => this.calcChange(row.containerPriceRange.min,row.newContainerPrice), sortable: true },        
        { name: 'updatedAt', required: false, label: 'Updated', align: 'right', field: row => moment(row.updatedAt).format('DD MMM YYYY - hh:mm:ssa'), sortable: true },
        { name: 'createdAt', required: false, label: 'Created', align: 'right', field: row => moment(row.createdAt).format('DD MMM YYYY - hh:mm:ssa'), sortable: true },        
     ]
    },



  async generateColourGridForNewProducts (){
    this.newProducts.forEach(product => {
      this.$set(this.newProductsGrid,product.reference,{})
    })

    for(let formColour in this.curatedColours){
      let colourId = this.curatedColours[formColour]._id
      this.$set(this.colourListNewProducts,colourId,_.cloneDeep(this.colourList[colourId]))
      this.$set(this.selectAllStateNewProducts,colourId,true)
      this.newProducts.forEach(product => {
        this.$set(this.newProductsGrid[product.reference],colourId,{
          state:true,
          price:0,
          showInContainer:true
        })
      })
    }

    for(let colour of this.selectedAdditionalColours){
      this.$set(this.colourListNewProducts,colour.id,_.cloneDeep(this.colourList[colour.id]))
      this.$set(this.selectAllStateNewProducts,colour.id,true)
      this.newProducts.forEach(product => {
        this.$set(this.newProductsGrid[product.reference],colour.id,{
          state:true,
          price:0,
          showInContainer:true
        })
      })      
    }

    console.log("COLOUR GRID NEW PRODUCTS",this.newProductsGrid)
  },
    async matchByName (){
        let found = false;
        let productMatch = [];
        let notMatch = [];
        this.foundProducts = []
        this.newProducts = []

        this.productsGeneratedFromOrderForm.forEach(genProd => {
          let match = false
          this.productsFromDB.forEach(DBproduct => {
            if(!match &&((
                // (DBproduct.name == genProd.name)||
                // (DBproduct.reference == genProd.name)||
                (DBproduct.reference == genProd.reference)
              ))){
              match = true
              let attributes = Object.keys(DBproduct.attributes)
              console.log('ATTRIBUTES',attributes);
              
              // attributes.forEach(attribute => {
              for(let attribute of attributes){
                if(genProd[attribute] && attribute != "bolts" && attribute != 'screws'){

                  let genProdValue = genProd[attribute]
                  if(typeof genProdValue == "string" && attribute != "material"){
                    genProdValue =  properCase(genProdValue.trim())
                  }
                  let dbProdValue = DBproduct.attributes[attribute]

                  console.log('LOOK FOR',attribute,genProdValue);
                  console.log("ATTR:",attribute,String(dbProdValue).toLowerCase(),"<->",String(genProdValue).toLowerCase(),"=",(String(dbProdValue).toLowerCase() != String(genProdValue).toLowerCase()));

                                      
                  if(String(dbProdValue).toLowerCase() != String(genProdValue).toLowerCase()){
                    DBproduct.differences[attribute] = { old: dbProdValue, new: genProdValue };                               
                  }              
                }               
              }
              // console.log('COMPARING NAME');
              
              // console.log(String(DBproduct.name).toLowerCase(),"<->",String(genProd.name).toLowerCase(),"=", String(DBproduct.name).toLowerCase() != String(genProd.name).toLowerCase());

              let genProdName = genProd.name
              // if(typeof genProdName == "string"){
              //   genProdName = properCase(genProdName.trim())
              // }

              let dbProdName = DBproduct.name
              
              if(String(dbProdName).toLowerCase().trim() != String(genProdName).toLowerCase().trim()){
                    DBproduct.differences.name = { old: dbProdName, new: genProdName };                 
              }     
              DBproduct.newContainerPrice = genProd.newContainerPrice
              DBproduct.key = genProd.key
              DBproduct.hyperlinks = genProd.hyperlinks
              DBproduct.colours = genProd.colours
              productMatch.push({product:genProd,DBproduct:DBproduct})  
              console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^GENPROD:',genProd,"DBProd:",DBproduct);
              
              this.foundProducts.push(DBproduct);              
            }
          })
          
          if(!match){
            this.newProducts.push(this.createFormatedProduct(genProd))
          }
        })

        let coloursFoundInExistingProducts = [];
        let sku_col = []
        let skuCounter = 0;

        for(let product of this.foundProducts){
          this.$set(this.productsGrid,product.reference,{})
          for(let sku of product.skus){
            skuCounter++
            this.$set(this.productsGrid[product.reference],sku.colour,{
              state:true,
              price:0,
              showInContainer:true,
              originalData:{
                state:true,
                skuId:sku.id,
                showInContainer:sku.showInContainer
              }
            })
            sku_col.push(`${sku.id},${sku.colour}`)
            if(coloursFoundInExistingProducts.length == 0 || !coloursFoundInExistingProducts.includes(sku.colour)){
              coloursFoundInExistingProducts.push(sku.colour);
              this.$set(this.selectAllState,sku.colour,true)
            }
          }
        }
        console.log('====>',sku_col);
        
        console.log('coloursFoundInExistingProducts',coloursFoundInExistingProducts);
        

        let colourInForm = []

        for(let formColour in this.curatedColours){
          let colourId = this.curatedColours[formColour]._id
          colourInForm.push(colourId)          
          if(!coloursFoundInExistingProducts.includes(colourId)){
            this.$set(this.selectAllState,colourId,false)
          }
        }  

        for(let colourInProd of coloursFoundInExistingProducts){
          console.log('colourInProd of coloursFoundInExistingProducts',colourInProd);
          
          let index = colourInForm.indexOf(colourInProd);
          if(index >= 0){
            this.coloursInProductsAndOrderForm.push(colourInProd)
            colourInForm.splice(index,1)
          }else{
            this.coloursOnlyInProducts.push(colourInProd)
          }
        }

        this.coloursOnlyInOrderForm = colourInForm

        this.extraColours = []

        for(let additionalC of this.selectedAdditionalColours){
          if(!coloursFoundInExistingProducts.includes(additionalC.id) && !colourInForm.includes(additionalC.id) && !this.coloursInProductsAndOrderForm.includes(additionalC.id) && !this.coloursOnlyInProducts.includes(additionalC.id)){
            this.extraColours.push(additionalC.id);
            // this.coloursOnlyInProducts.push(additionalC.id)
            this.$set(this.selectAllState,additionalC.id,false)
          }
        }

        for(let colourId of this.coloursOnlyInProducts){
          console.log('AAAAAAAAA GETTING ID:',colourId);
          
          let colourObj = await this.getColourById_query(colourId);
          console.log('AAAA GOT',colourObj);
          
          this.$set(this.colourList,colourId,colourObj)
        }

        for(let colourId of this.coloursInProductsAndOrderForm){
          console.log('BBBBBBBBB GETTING ID:',colourId);          
          let colourObj = await this.getColourById_query(colourId);
          console.log('BBBB GOT',colourObj);
          this.$set(this.colourList,colourId,colourObj)
        }

        for(let colourId of this.coloursOnlyInOrderForm){
          console.log('CCCCCCCC GETTING ID:',colourId);          
          let colourObj = await this.getColourById_query(colourId);
          console.log('CCCC GOT',colourObj);
          this.$set(this.colourList,colourId,colourObj)
        }

        for(let colourId of this.extraColours){
          console.log('DDDDDDDDD GETTING ID:',colourId);          
          let colourObj = await this.getColourById_query(colourId);
          console.log('DDDD GOT',colourObj);

          this.$set(this.colourList,colourId,colourObj)
        }
        
        for(let colourId in this.colourList){
          for(let reference in this.productsGrid){
            if(!this.productsGrid[reference][colourId]){
              this.$set(this.productsGrid[reference],colourId,{
                state:false ,
                price:0,
                showInContainer:true
              })
            }
          }
        }

        // console.log("************GRID",this.productsGrid)
        // process.exit(0)

        // console.log('results: ',"MATCH ",productMatch.length, "\nNOT MATCH ", notMatch.length);
        // console.log('Foundproducts:',this.foundProducts);
        // console.log('UColours:',uniqueColours,"C:",uniqueColours.length);
        // console.log('SKUCount:',skuCounter);
        // console.log('colourGRID0000000000000000000000',this.colourGrid);
        // console.log('this.colourList00000000000000000',this.colourList);
        
        
        this.generateColourGridForNewProducts();
        this.allDone = true;       

    },
    async addDifferences(product,attribute,oldVal,newVal){
      return new Promise(async(resolve,reject)=>{

      });
    },

    createFormatedProduct(productData){
      let productTemplate = {
        name: '',
        price: 0,
        newContainerPrice: 0,
        urlSlug: '',
        description:'',
        reference: '',
        attributes:{
          manufacturer: '',
          type: '',
          brand: '',
          range: '',
          grip: '',
          material: '',
          size: '',
          holds: ''
        },
        skus:[],
        hyperlinks:[],
        colours:[]
      }

      let product = _.cloneDeep(productTemplate)

      product.selected =  true;
      product.key = productData.key

      for(let property in product){
 
        if(productData[property]){
          let value = productData[property];
          if(typeof value == "string" && property != "reference" ){
            value = properCase(value.trim())
          }          
          product[property] = value
        }

        if(property == "attributes"){
          for(let attribute in product.attributes){
            if(productData[attribute]){
              let attributeValue = productData[attribute]
              if(typeof attributeValue == "string" && attribute != "material"){
                attributeValue = properCase(attributeValue.trim())
              }
              product.attributes[attribute] = attributeValue
            }
          }
        }
      }

      if(productData.colours){
        product.colours = _.cloneDeep(productData.colours)
      }
    console.log('DATA USED BRANDNEW PRODUCT',productData);
    
    console.log("BRANDNEW PRODUCT",product)      

      return product
    },

    calcChange(previousValue,newValue){
      if(previousValue == 0){
        return 100
      }
      
      let val = (-100 * (Number(previousValue) - Number(newValue))) / Number(previousValue) || 0
      return val.toFixed(2)
      
    },
    async getProductsFromDatabase () {

      let productsFromDatabase = await this.productsByManufacturerAndBrand(this.productManufacturer,this.productBrand);

      for(let product of productsFromDatabase){
        product.differences = {}
        product.selected = true
        product.colours = [];
        product.colourRow = {};
        product.newContainerPrice = 0;
        product.key = '';
        this.getAveragePrice(product)
      }

      this.showLoadingPriceSelectorPage = false
      this.showPriceSelectorPage = true
      return productsFromDatabase
    },

    async getAveragePrice(product){
      let isRange =  true
      let containerPrices = []
      let string, min, max;
      

      product.skus.forEach(sku => {
        containerPrices.push(sku.containerPrice)
      })

      if(containerPrices.length){
        min = Math.min(...containerPrices)
        max = Math.max(...containerPrices)

        if(min == max){
          isRange = false
          string = max
        }else{
          string = `${min} - ${max}`
        }
        
        if(isRange){
          product.selected = false;
        }
      }
      product.containerPriceRange = (containerPrices.length) ? {isRange:isRange,min:min,max:max,string:string} : {isRange:false,min:0,max:0,string:"NaN"}     
    },
    setSheetToUse(sheetName){
        try{
          this.worksheet = this.workbook.getWorksheet(sheetName);
          this.worksheet.eachRow((row,rowNumber)=>{
            if(row.hidden){
              this.hiddenRows.push(rowNumber)
            }
          })

          this.enableToStep2 = true;
          this.showAttributesList = true;
        }catch(error){
          this.showAttributesList = false;
          this.enableToStep2 = false;
          this.sheetSelected = ""
          console.log('Error selecting XLSX sheet:',sheetName,error)
        }
    },
    resetFilePicker(file,removeFileFn){
        removeFileFn(file);
        this.filename = "";
        this.showSheetSelector = false;
        this.enableToStep2 = false;
        this.sheets = []
        this.sheetSelected = ""
        this.fileProcess = {status:"Loading",loading:false,errorMessage:""}
    },
    pressed(v,att,index){
      let inputCheck = this.splitAddress(v);
      if( index > 1 && (   (inputCheck.col != '' && !isNaN(inputCheck.row)) || (inputCheck.col != '' && isNaN(inputCheck.row)) || (inputCheck.col == '' && !isNaN(inputCheck.row)))){
        let previousRangeData  = this.attributes[index-1].range;
        let range = previousRangeData.split(":");
        let res = this.getTypeAndIndex(range);
        if((res.type == "col" && (inputCheck.col != '' && isNaN(inputCheck.row))) || (res.type == "row" && (inputCheck.col == '' && !isNaN(inputCheck.row)))){
          var reg = new RegExp(res.pivot, "g");
          att.range = previousRangeData.replace(reg,v)
        }
      }      
    },


    createNomarmalisedRageFromAttributeInput(inputRange){
      function rangeAsFormatedObject(range){
        let rangeTerms = range.split(":")
        return (rangeTerms.length) == 1 ? {from:rangeTerms[0].toUpperCase(),to:rangeTerms[0].toUpperCase()} : {from:rangeTerms[0].toUpperCase(),to:rangeTerms[1].toUpperCase()};
      }
      if(inputRange.includes("-")){
        // "-" means that is a segmented range A1:A5-A10:A20
        let individualRanges = inputRange.split("-")
        let ranges = []
        for(let range of individualRanges){
          ranges.push(rangeAsFormatedObject(range))
        }
        return ranges
      }else if(inputRange.includes('"')){
        // input with double quotes sould be considered a string and shouldn't be processed as a range,
        console.log('input with double quotes sould be considered a string and shouldn\'t be processed as a range');
        return []
      }else{
        //Any other input is considered a range 
        let range = []
        range.push(rangeAsFormatedObject(inputRange))
        return range;
      }
    },

    async getValuesOfAttributes(){
      let dataValues = {};

      this.hiperlinksList = {};
      console.log('this.attributes2',this.attributes2);
      
      for(let attributeName in this.attributes2){
        if(this.attributes2[attributeName].range.includes('"')){
          this.constantAttributes[attributeName] = this.attributes2[attributeName].range;
        }
        else if(this.attributes2[attributeName].range != ""){
          let enumAttribute = {};
          let selectedAttribute = this.attributes2[attributeName];

          if(selectedAttribute.addAttribute)
            this.selectionOfAttributes.push(attributeName);
          if(selectedAttribute.id == this.attributeAsReference)
            this.referenceAttribute = attributeName;

          let dataRange = await this.createNomarmalisedRageFromAttributeInput(selectedAttribute.range)
          let values =  await this.getValuesInRange(dataRange);
          
          let attributeRef = this.getReferenceIndexList(values);
          console.log('COMPA',this.referenceAttribute,"+++++",attributeName);     
          if(this.referenceAttribute == attributeName){
            console.log('XXXXX REFLIST',attributeRef.list);       
            this.referenceIndexList = attributeRef.list
          }
          enumAttribute["ref"] = {pivot:attributeRef.pivot,index:attributeRef.index,type:attributeRef.type};

          for(let address in values){
            let link = undefined
            let itemAddress = this.splitAddress(address);
            if(Object.keys(this.hiperlinksList).length > 0){  
              link = this.hiperlinksList[address]
            }
            let valueObj = {value:values[address],address:address,row:itemAddress.row,col:itemAddress.col,hyperlink:link}            

            if(attributeName == "colour" && this.notesList && this.notesList[address]){              
              valueObj.value = this.notesList[address]
            }
            enumAttribute[itemAddress[attributeRef.index]] = valueObj
          }
          dataValues[attributeName] = enumAttribute;
        }
      }
      return dataValues
    },

    async process(){
        // setup
        this.dataRanges = []
        this.selectionOfAttributes = []
        this.referenceAttribute = []
        this.productsGeneratedFromOrderForm = []
        this.coloursProcessed = false;
        this.tableHeaders


        console.log('ATTRIBUTES:',this.attributes);

        //Get all the values from all the ranges
        this.attributesDataValues = await this.getValuesOfAttributes()
        console.log("$$$$$$$$$$$$$VALUES",this.attributesDataValues)

        console.log('COLOURS IN ORDER FORM',this.attributesDataValues["colour"]);



        this.processColour()


        this.showLoadingColourSelectorPage = false;
        this.showColourSelectorPage = true;


    },
    async processColour(){
      let rawColourNames = []     
      for(let key in this.attributesDataValues['colour']){
        if(key != "ref")
          rawColourNames.push(this.attributesDataValues['colour'][key].value)
      }
      console.log('rawColourNames',rawColourNames);
      this.coloursMatched = JSON.parse(await this.matchColours(rawColourNames,this.productManufacturer,this.productBrand,this.productMaterial))
      console.log(this.coloursMatched)
      this.getAdditionalColours()
    },
    async secondStepProcess(){
        this.productsGeneratedFromOrderForm = await this.genProductsList(this.attributesDataValues,this.selectionOfAttributes,this.referenceAttribute);
        // create table header
        this.tableHeaders = ['key',...this.selectionOfAttributes,'colour'];
        console.log('NP',this.productsGeneratedFromOrderForm.length);
        this.productsFromDB = await this.getProductsFromDatabase();
        console.log("*******************PRODFDB",this.productsFromDB)
        await this.matchByName()
    },
    async productsByManufacturerAndBrand (manufacturer,brand) {
      const result = await this.$apollo.query({
        query: gql`query productsByManufacturerAndBrand($manufacturer: String!,$brand: String!){
          productsByManufacturerAndBrand(manufacturer:$manufacturer,brand:$brand){
              id
              name
              description
              reference
              images {
                url
                name
              }
              attributes
              urlSlug
              skus {
                id
                colour
                attributes
                barcode
                options
                price
                containerPrice
                retailPrice
                showInRetail
                showInContainer
                hideInStock
                stock
                updatedAt
                createdAt
              }
              updatedAt
              createdAt              
            }
        }`,
        variables: {
          manufacturer: manufacturer,
          brand: brand
        },
        fetchPolicy: 'network-only'
      })
      console.log(result.data.productsByManufacturerAndBrand)
      return result.data.productsByManufacturerAndBrand
    },
     async xlsxUploader(files){
        try{ 
            this.fileProcess.status = "Loading";
            this.fileProcess.loading = true;
            this.showSheetSelector = false;
            this.showAttributesList = false;
            this.sheets = []
            this.hiddenRows = []
            this.filename = files[0]

            this.workbook = new Excel.Workbook(); 
            await this.workbook.xlsx.load(this.filename).then(async(r) =>{
              let sheets = this.listWorksheet(this.workbook);
              sheets.forEach(sheet => {
                this.sheets.push(sheet.name)
              });

              this.showSheetSelector = true;
              this.fileProcess.status = "Done"
              this.fileProcess.loading = false;
            })
        }catch(error){
            this.fileProcess.status = "Error"
            this.fileProcess.loading = false;
            this.fileProcess.errorMessage = error   ;
        }
     },

     listWorksheet(workbook,showAll = false){
        let worksheetList = []
        workbook.eachSheet(function(worksheet, sheetId) {
            if(showAll){
                worksheetList.push({name:worksheet.name,id:worksheet.id,orderNo:worksheet.orderNo,state:worksheet.state})
            }else{
                if(worksheet.state == "visible")
                    worksheetList.push({name:worksheet.name,id:worksheet.id,orderNo:worksheet.orderNo,state:worksheet.state})
            }
        });
        return worksheetList;
    },
    /**
    * Get a cell address or location as object format. eg "K9" as {col:"K",row:9}
    * @param {String} address - Single cell address or location in format "K9"
    */
    splitAddress(address){
        let terms = address.split(/([0-9]+)/);
        return ({
            col:terms[0],
            row:Number(terms[1])
        })
    },
    async getValuesInRange(range){
        let result = {};
        let ref = this.getTypeAndIndex([range[0].from,range[0].to])
        let selection = await this.getRange(range);
        for (const cell in selection) {      
          console.log('+++++++++++++++++++',selection[cell].value);   
            if(selection[cell].note){
              let notes = []
              for(let texts of selection[cell].note.texts){
                let t = texts.text.replace(/\n/g," ")
                notes.push(t.trim())
              }
              this.notesList[cell] = notes.join(" ")
            }    
            if(typeof selection[cell].value == "object" && selection[cell].value != null){
                result[cell] = selection[cell].text.replace(/\s+/g, ' ').trim()
                if(selection[cell].value.hyperlink) this.hiperlinksList[cell] = selection[cell].value.hyperlink
                
            }else if(selection[cell].value != null && typeof selection[cell].value == "string"){
                result[cell] = selection[cell].value.replace(/\s+/g, ' ').trim();
            }else if(selection[cell].value != null){
                result[cell] = selection[cell].value;
            }
        }        
        return result;
    },
    async getRange(range){
        let isValid = this.validateRange(range);
        if(!isValid){
            console.log('ERROR: NOT VALID RANGE',range);
            return        
        }
        let rangeList = [];
        let rangeObjects = {};

        for (const rangeSet of range ){
            let list = this.generateRangeList(rangeSet);
            rangeList = rangeList.concat(list)
        };

        //with the list build object calling every cell   
        for(const cell of rangeList){
            // for(i=0; i < rangeList.length; i++){
            // let cell = rangeList[i];
            let cellData = await this.getCell(cell);
                      
            Object.assign(rangeObjects,cellData);   
        }
        return rangeObjects;
    },
    validateRange(range){
        let validate = this.getTypeBaseline(range[0]);
        let isValidRange = true

        range.forEach(set => {
            let from = this.splitAddress(set.from)
            let to = this.splitAddress(set.to)
            if(validate.type == "col"){
                if(!(from.col == validate.baseline && to.col == validate.baseline)){
                    isValidRange = false
                }
            }
            if(validate.type == "row"){
                if(!(from.row == validate.baseline && to.row == validate.baseline)){
                    isValidRange = false
                }
            }
        })
        return isValidRange;
    },
    getTypeBaseline (address){
        let from = this.splitAddress(address.from)
        let to = this.splitAddress(address.to)
        let baseline;
        let type;

        if(from.col == to.col && from.row == to.row){
            type = "same"
            baseline = false
        }else if(from.col == to.col){
            type = "col"
            baseline = from.col
        }else if(from.row == to.row){
            type = "row"
            baseline = from.row
        }else{
            console.log('Not common Row or column found.');
        }
        return { "baseline":baseline,"type":type };
    },
    generateRangeList(rangeSet){    
        let validate = this.getTypeBaseline(rangeSet);
        let type = validate.type;
        let from = this.splitAddress(rangeSet.from)
        let to = this.splitAddress(rangeSet.to)

        if(type == "same"){
            //not a range but a single item
            return [`${from.col}${from.row}`]
        }

        if(type == "col"){
            let rangeValue = from.row - to.row;
            let list= [];       

            if(rangeValue > 0){
                rangeValue++
                let rangeList = _.range(rangeValue);
                rangeList.forEach(v => {
                    list.push(to.col+(to.row+v))
                })
            }else{
                rangeValue--
                let rangeList = _.range(rangeValue);
                rangeList.forEach(v => {                
                    list.push(from.col+(from.row-v))
                })          
            }
            return list;
        }

        if(type == "row"){
            let numericColFrom = colString.excelColToInt(from.col)
            let numericColTo =  colString.excelColToInt(to.col)
            let rangeValue = numericColFrom - numericColTo;
            let list= [];  

            if(rangeValue > 0){
                rangeValue++
                let rangeList = _.range(rangeValue);
                rangeList.forEach(v => {
                    let col = colString.intToExcelCol(numericColTo + v)
                    list.push(col+to.row)
                })
            }else{
                rangeValue--
                let rangeList = _.range(rangeValue);
                rangeList.forEach(v => {                
                    let col = colString.intToExcelCol(numericColFrom - v)
                    list.push(col+to.row)
                })          
            }
            return list;
        }
    },
    async getCell(cellAddress){
        return new Promise(async (resolve,reject)=>{            
            let cell = await this.worksheet.getCell(cellAddress);
            resolve ({[`${cell.address}`]:cell})
        });
    },
    addVariation(products,variation,attribute){
        let reference =  this.getReferenceIndexList(variation)
        let newProductsWithVariation = [];
        products.forEach(product =>{
            if(reference.list.includes(product.key)){
                let prod = Object.assign({}, product);
                let keyword = reference.type == 'col' ? variation[reference.pivot+product.key] : variation[product.key + reference.pivot];
                prod[attribute] = `${product[attribute]} ${keyword}`
                newProductsWithVariation.push(prod);
            }
        })

        products = products.concat(newProductsWithVariation);
        return products;  
    },
    getTypeAndIndex(addresses){
        let address1 = this.splitAddress(addresses[0]);
        let address2 = this.splitAddress(addresses[1]);
        let index;
        let type;
        let pivot;
        if(address1.col == address2.col){
            index = "row";
            type = "col";
            pivot = address1.col;
        }
        if(address1.row == address2.row){
            index = "col";
            type = "row";
            pivot = address1.row;
        }
        return {index:index,type:type,pivot:pivot}
    },
    getReferenceIndexList(reference){
        let indexList = [];
        let referenceKey = Object.keys(reference);

        if(referenceKey.length > 1){
            let indexAndType = this.getTypeAndIndex([referenceKey[0],referenceKey[1]])
            let index = indexAndType.index;
            let type = indexAndType.type;
            let pivot = indexAndType.pivot;


            for(let refKey in reference){
               if(reference[refKey] != null){
                  let key = this.splitAddress(refKey);
                  if(!this.hiddenRows.includes(key[index])){
                    indexList.push(key[index])
                  }else{
                    console.log('SKIP ROW:',key[index]," HIDDEN ROW");
                  }

               }
            }
            return {list:indexList,index:index,type:type,pivot:pivot}
        }
    },
    loadAttributes (){     
      this.productManufacturer = this.selectedSavedOFData.attributes.manufacturer
      this.productBrand = this.selectedSavedOFData.attributes.brand
      this.productMaterial = this.selectedSavedOFData.attributes.material
      this.attributeAsReference = this.selectedSavedOFData.attributes.attributeAsReference

      if(this.selectedSavedOFData.attributes.rules){
        this.rules = this.selectedSavedOFData.attributes.rules
        delete this.selectedSavedOFData.attributes.rules       
      }

      //delete alredy used
      delete this.selectedSavedOFData.attributes.manufacturer
      delete this.selectedSavedOFData.attributes.brand
      delete this.selectedSavedOFData.attributes.material
      delete this.selectedSavedOFData.attributes.attributeAsReference       
    
      this.attributes2 = this.selectedSavedOFData.attributes;
      notifyMessage(this.$q,"Loaded Attributes Ranges",this.selectedSavedOFData.name);
      this.dataLoaded = true;
      
    },   
    loadMatched(){
      this.allDone = true
    },

    async genProductsList (attributes,attributeKey,reference){
      console.log("attributes\n",attributes,"\n\nattributeKey\n",attributeKey,"\n\nreference\n",reference);
        let preProduct = [];     

        console.log('attributes',attributes);
        console.log('referenceIndexList',this.referenceIndexList);

        for(let i of this.referenceIndexList){
          if(!this.hiddenRows.includes(i)){
            let product = _.cloneDeep(this.productTemplate)
            product.key = i;
            product.hyperlinks = []

            for(let property in product){
              if(property == 'manufacturer'){
                product[property] = this.productManufacturer.trim()
              }
              if(property == 'brand'){
                product[property] = this.productBrand.trim()
              }
              if(property == 'material'){
                product[property] = this.productMaterial.trim()
              }                                
              // console.log('attributes[property]',property,attributes[property]);
              if(attributes[property] && property != "colours"){
                console.log('LOOKING FOR:',property,i,attributes[property][i]); 
                let value = attributes[property][i].value
                if(typeof value == "string"){
                  value = value.trim()
                }        
                product[property] = value
                if(attributes[property][i].hyperlink) product.hyperlinks.push(attributes[property][i].hyperlink)
              }

              if(property == 'newContainerPrice'){
                product[property] = this.getNewPrice(product.price).calculatedWithUpsale
              }

              //Set all the "constant Attributes"
              if(this.constantAttributes[property]){           
                product[property] = this.constantAttributes[property].replace(/\"/g,"").trim();
              }

              if(property == "colours"){
                let refData = attributes["colour"].ref;
                let type = refData.type;
                for(let key in attributes["colour"]){
                  if(key != "ref"){
                    let row;
                    let col;
                    if(type == "row"){
                      col = attributes["colour"][key].col
                      row = i
                    }else{
                      col = i;
                      row = attributes["colour"][key].row
                    }
                    product.colours.push({
                      name:attributes["colour"][key].name,
                      id:attributes["colour"][key].id,
                      group:attributes["colour"][key].group,
                      supergroup:attributes["colour"][key].supergroup,
                      hex:attributes["colour"][key].hex,
                      legacyColour:attributes["colour"][key].legacyColour,
                      formColour:attributes["colour"][key].value,
                      cellLocation:col+row,
                      col:col,
                      row:row,
                      containerPrice:attributes["price"][i].value,
                      available:true})
                  }                     
                } 
              }
            }
            for(let property in product){
              if(this.rules[property]){
                product[property] = await this.evaluateRules(product[property],this.rules[property])
                if(property == 'price'){
                  product.newContainerPrice = this.getNewPrice(product.price).calculatedWithUpsale
                }                
              }
            }
            

                          
            preProduct.push(product);
          }
        }
        console.log('prepro',preProduct);
        return preProduct; 
    },
		async getColourById_query(id){
      try {
        const result = await this.$apollo.query({
          query: gql`
					query colourById ($id: ID!) { 
						colourById (id: $id) { 
							id, 
							name, 
							supergroup, 
							group, 
							hex, 
							manufacturer, 
							brand, 
							material, 
              legacyColour
							notes,
							createdAt,
							updatedAt 
							} 
						} 
					`,
					variables: {
						id: id
					}
        })
        console.log('getColourById_query',result.data.colourById);
        			
        return result.data.colourById;
      } catch (error) {
        console.log("getColourById_query Error:", error)
        throw new Error(error);    
      }      
    },	                  
    
  },
  async created(){
    this.setRevisions()
  } 
}
</script>